import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type Account = {
  __typename?: 'Account';
  email: Scalars['String'];
  features?: Maybe<Array<Scalars['JSON']>>;
  guid: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ActivePeriod = {
  __typename?: 'ActivePeriod';
  amount?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type ActivePeriodInputType = {
  amount?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type AddUserAttributeResponse = {
  __typename?: 'AddUserAttributeResponse';
  details?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export enum AggregateRecipientsBodyPropertyDataTypeEnum {
  Boolean = 'Boolean',
  Date = 'Date',
  Number = 'Number',
  String = 'String'
}

export type AggregateRecipientsBodyPropertyInput = {
  dataType?: InputMaybe<AggregateRecipientsBodyPropertyDataTypeEnum>;
  integrationId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  property: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};

export type AggregationResultGraphql = {
  __typename?: 'AggregationResultGraphql';
  hasMoreValues?: Maybe<Scalars['Boolean']>;
  integrationId: Scalars['String'];
  property: Scalars['String'];
  size: Scalars['Float'];
  values: Array<AggregationValueGraphql>;
};

export type AggregationValueGraphql = {
  __typename?: 'AggregationValueGraphql';
  amount: Scalars['Float'];
  globalAmount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type AggregationsResultsGraphql = {
  __typename?: 'AggregationsResultsGraphql';
  count: Scalars['Int'];
  propertiesAggregations: Array<AggregationResultGraphql>;
};

export type AllRecipientsData = {
  __typename?: 'AllRecipientsData';
  activeEndUsersCount?: Maybe<Scalars['Float']>;
  /** @deprecated Use `activeEndUsersCount` instead */
  activeEndUsersWithIntegrationsDataCount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['String']>;
  endUsersCount?: Maybe<Scalars['Float']>;
  hasIntegrationData?: Maybe<Scalars['Boolean']>;
  inactiveEndUsersCount?: Maybe<Scalars['Float']>;
  maxIdentifierCount?: Maybe<Scalars['Float']>;
  /** @deprecated Use `inactiveEndUsersCount` instead */
  nonActiveEndUsersCount?: Maybe<Scalars['Float']>;
  notificationsNumber: Scalars['Float'];
  potentialEndUsersCount?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export enum AnalyticsSource {
  Legacy = 'Legacy',
  Workstation = 'Workstation'
}

export type AnalyticsSourcesData = {
  __typename?: 'AnalyticsSourcesData';
  hasLegacyAnalytics: Scalars['Boolean'];
  hasWorkstationAnalytics: Scalars['Boolean'];
  useElectronAnalytics: Scalars['Boolean'];
};

export type AnalyticsSummaryResult = {
  __typename?: 'AnalyticsSummaryResult';
  clicks: Scalars['Float'];
  receives: Scalars['Float'];
  usersClicks: Scalars['Float'];
  usersReceived: Scalars['Float'];
  usersViewed: Scalars['Float'];
  views: Scalars['Float'];
};

export type AudienceCreateInputType = {
  data: AudienceDataInputType;
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  user: UserInputType;
};

export type AudienceDataGraphql = {
  __typename?: 'AudienceDataGraphql';
  color?: Maybe<Scalars['String']>;
  rules: Array<AudienceRuleGraphql>;
};

export type AudienceDataInputType = {
  color?: InputMaybe<Scalars['String']>;
  rules: Array<AudienceRuleInputType>;
};

export type AudienceGraphql = {
  __typename?: 'AudienceGraphql';
  conditionBlockId?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  data?: Maybe<AudienceDataGraphql>;
  description: Scalars['String'];
  id: Scalars['String'];
  notificationsNumber?: Maybe<Scalars['Int']>;
  notificationsStatus?: Maybe<Scalars['JSON']>;
  numericId: Scalars['Float'];
  publishState?: Maybe<Scalars['Int']>;
  size: Scalars['Float'];
  sizeInactive?: Maybe<Scalars['Float']>;
  sizeInactiveLastChangedAt?: Maybe<Scalars['String']>;
  sizeLastChangedAt?: Maybe<Scalars['String']>;
  sizeLastUpdateAt?: Maybe<Scalars['String']>;
  sizeTotal?: Maybe<Scalars['Float']>;
  sizeTotalLastChangedAt?: Maybe<Scalars['String']>;
  systemId: Scalars['String'];
  title: Scalars['String'];
  type?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['String'];
  user: UserGraphql;
};

export type AudienceInfo = {
  audienceId: Scalars['String'];
  audienceName: Scalars['String'];
};

export enum AudienceRuleDataTypeEnum {
  Boolean = 'Boolean',
  Date = 'Date',
  Number = 'Number',
  String = 'String'
}

export type AudienceRuleGraphql = {
  __typename?: 'AudienceRuleGraphql';
  alias?: Maybe<Scalars['String']>;
  conditionGuid?: Maybe<Scalars['String']>;
  dataType?: Maybe<AudienceRuleDataTypeEnum>;
  integrationId?: Maybe<Scalars['String']>;
  operator?: Maybe<AudienceRuleOperatorEnum>;
  property: Scalars['String'];
  values: Array<IntegrationPropertyValueGraphql>;
};

export type AudienceRuleInputType = {
  alias?: InputMaybe<Scalars['String']>;
  conditionGuid?: InputMaybe<Scalars['String']>;
  dataType?: InputMaybe<AudienceRuleDataTypeEnum>;
  integrationId?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<AudienceRuleOperatorEnum>;
  property: Scalars['String'];
  values: Array<IntegrationPropertyValueInput>;
};

export enum AudienceRuleOperatorEnum {
  Contains = 'Contains',
  In = 'In',
  NotIn = 'NotIn'
}

export type AudienceUpdateInputType = {
  data?: InputMaybe<AudienceDataInputType>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  publishState?: InputMaybe<Scalars['Int']>;
  size: Scalars['Float'];
  sizeInactive: Scalars['Float'];
  sizeTotal: Scalars['Float'];
  title: Scalars['String'];
  user: UserInputType;
};

export type AudiencesList = {
  __typename?: 'AudiencesList';
  archivedAudiencesList: Array<AudienceGraphql>;
  audiencesList: Array<AudienceGraphql>;
};

export enum CalculateRecipientsForFilterBodyRecipientsFilterEnum {
  Active = 'Active',
  All = 'All',
  Inactive = 'Inactive',
  Potential = 'Potential'
}

export enum ContentItemType {
  Category = 'Category',
  Collection = 'Collection',
  Course = 'Course',
  Folder = 'Folder',
  Label = 'Label',
  Launcher = 'Launcher',
  Lesson = 'Lesson',
  Resource = 'Resource',
  Segment = 'Segment',
  Shoutout = 'Shoutout',
  Shuttle = 'Shuttle',
  SmartTipSet = 'SmartTipSet',
  SmartWalkThru = 'SmartWalkThru',
  Task = 'Task',
  WalkThru = 'WalkThru'
}

export type CreateAudienceOutput = {
  __typename?: 'CreateAudienceOutput';
  audience: AudienceGraphql;
  audiences: Array<AudienceGraphql>;
  publishResult?: Maybe<PublishResultGraphql>;
};

export type CreateReportResult = {
  __typename?: 'CreateReportResult';
  recordsSent: Scalars['Int'];
};

export type CreateUpdateNotificationsResult = {
  __typename?: 'CreateUpdateNotificationsResult';
  notifications: Array<Notification>;
  publishResult?: Maybe<PublishResult>;
};

export type DateRange = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  type: DateRangeType;
};

export enum DateRangeType {
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_90Days = 'LAST_90_DAYS'
}

export type DayRules = {
  __typename?: 'DayRules';
  daysInMonth?: Maybe<Array<Scalars['Int']>>;
  daysInWeek?: Maybe<Array<Scalars['Int']>>;
  daysRepeat?: Maybe<Scalars['Int']>;
};

export type DayRulesInputType = {
  daysInMonth?: InputMaybe<Array<Scalars['Int']>>;
  daysInWeek?: InputMaybe<Array<Scalars['Int']>>;
  daysRepeat?: InputMaybe<Scalars['Int']>;
};

export type DeleteAudiencesOutput = {
  __typename?: 'DeleteAudiencesOutput';
  deletedCount: Scalars['Float'];
  deletedIds: Array<Scalars['String']>;
  publishResult?: Maybe<PublishResultGraphql>;
};

export type DeleteImageInput = {
  fileName: Scalars['String'];
  userGuid: Scalars['String'];
};

export type DeleteNotificationsResult = {
  __typename?: 'DeleteNotificationsResult';
  deletedCount: Scalars['Float'];
  deletedIds: Array<Scalars['String']>;
  publishResult?: Maybe<PublishResult>;
};

export type Dependencies = {
  __typename?: 'Dependencies';
  dependencyId?: Maybe<Scalars['JSON']>;
  dependencyType?: Maybe<Scalars['Int']>;
};

export type DependenciesInputType = {
  dependencyId?: InputMaybe<Scalars['JSON']>;
  dependencyType?: InputMaybe<Scalars['Int']>;
};

export type DetailedAnalyticsResult = {
  __typename?: 'DetailedAnalyticsResult';
  /** @deprecated Use actionsClicksWithValues instead */
  actionsClicks?: Maybe<Scalars['JSON']>;
  actionsClicksWithValues?: Maybe<Scalars['JSON']>;
  clicks?: Maybe<Scalars['Float']>;
  delivered?: Maybe<Scalars['Float']>;
  numericId: Scalars['Float'];
  received?: Maybe<Scalars['Float']>;
  targeted?: Maybe<Scalars['Float']>;
  views?: Maybe<Scalars['Float']>;
  viewsDesktop?: Maybe<Scalars['Float']>;
  viewsMobile?: Maybe<Scalars['Float']>;
};

export type EndUserResultIntegrations = {
  __typename?: 'EndUserResultIntegrations';
  integrationId?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type GetNotificationsArgsQuery = {
  filters?: InputMaybe<Array<Array<Scalars['JSON']>>>;
  limit?: InputMaybe<Scalars['Float']>;
  page?: InputMaybe<Scalars['Float']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<GetNotificationsArgsSort>;
};

export type GetNotificationsArgsSort = {
  dataKey?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<SortDirection>;
};

export type ImageItem = {
  __typename?: 'ImageItem';
  extension: Scalars['String'];
  isOriginalSrc?: Maybe<Scalars['Boolean']>;
  lastModified: Scalars['String'];
  name: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
};

export type IntegrationFieldGraphql = {
  __typename?: 'IntegrationFieldGraphql';
  alias?: Maybe<Scalars['String']>;
  dataType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  role?: Maybe<IntegrationFieldRole>;
};

export enum IntegrationFieldRole {
  Identifier = 'Identifier',
  Property = 'Property',
  Unique = 'Unique'
}

export type IntegrationGraphql = {
  __typename?: 'IntegrationGraphql';
  fields: Array<IntegrationFieldGraphql>;
  id: Scalars['String'];
  identifier: IntegrationIdentifierGraphql;
  name: Scalars['String'];
  type?: Maybe<IntegrationTypeEnum>;
};

export type IntegrationIdentifierGraphql = {
  __typename?: 'IntegrationIdentifierGraphql';
  destination: Scalars['String'];
  source: Scalars['String'];
};

export type IntegrationPropertyValueGraphql = {
  __typename?: 'IntegrationPropertyValueGraphql';
  amount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type IntegrationPropertyValueInput = {
  amount?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
};

export enum IntegrationTypeEnum {
  Csv = 'Csv',
  Idp = 'Idp'
}

export enum Language {
  En = 'EN',
  Ja = 'JA'
}

export type MonthRules = {
  __typename?: 'MonthRules';
  monthsInYear?: Maybe<Array<Scalars['Int']>>;
  monthsRepeat?: Maybe<Scalars['Int']>;
};

export type MonthRulesInputType = {
  monthsInYear?: InputMaybe<Array<Scalars['Int']>>;
  monthsRepeat?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addUserAttributes: AddUserAttributeResponse;
  createAudience: CreateAudienceOutput;
  createNotification: CreateUpdateNotificationsResult;
  createNotificationEngagementReport: Scalars['Boolean'];
  createReport: CreateReportResult;
  createSystemVisualDesign: SystemVisualDesign;
  /** @deprecated should use createReportNew instead */
  createUsersWithoutWorkstationReport: CreateReportResult;
  deleteAudiences: DeleteAudiencesOutput;
  deleteImage: Scalars['String'];
  deleteNotifications: DeleteNotificationsResult;
  deleteSystemVisualDesign: Scalars['Float'];
  previewNotification: PreviewNotificationsResult;
  sendNotification: SendNotificationResponse;
  setSystemSettings: SystemSettings;
  updateAudiences: UpdateAudiencesOutput;
  updateNotifications: CreateUpdateNotificationsResult;
  updateSystemVisualDesign: SystemVisualDesign;
  uploadImage: Scalars['String'];
  uploadImageFromUrl: Scalars['String'];
};


export type MutationAddUserAttributesArgs = {
  userAttribute: UserAttributeInput;
};


export type MutationCreateAudienceArgs = {
  audience: AudienceCreateInputType;
  systemId: Scalars['String'];
};


export type MutationCreateNotificationArgs = {
  environmentId: Scalars['String'];
  notification: NotificationInputType;
  skipPublish?: InputMaybe<Scalars['Boolean']>;
  systemId: Scalars['String'];
};


export type MutationCreateNotificationEngagementReportArgs = {
  environmentId: Scalars['String'];
  language: Language;
  note?: InputMaybe<Scalars['String']>;
  notificationInfo: NotificationInfo;
  recipients: Array<Scalars['String']>;
};


export type MutationCreateReportArgs = {
  analyticsSource?: InputMaybe<AnalyticsSource>;
  dateRange?: InputMaybe<DateRange>;
  environmentId: Scalars['String'];
  language: Language;
  note?: InputMaybe<Scalars['String']>;
  recipients: Array<Scalars['String']>;
  reportParams?: InputMaybe<ReportParamsNew>;
  reportType?: InputMaybe<ReportTypes>;
  timezoneOffset: Scalars['Int'];
};


export type MutationCreateSystemVisualDesignArgs = {
  systemId: Scalars['String'];
  systemVisualDesign: VisualDesignInputType;
};


export type MutationCreateUsersWithoutWorkstationReportArgs = {
  environmentId: Scalars['String'];
  language: Language;
  recipients: Array<Scalars['String']>;
  timezoneOffset: Scalars['Int'];
};


export type MutationDeleteAudiencesArgs = {
  ids: Array<Scalars['String']>;
  systemId: Scalars['String'];
};


export type MutationDeleteImageArgs = {
  fileData: DeleteImageInput;
};


export type MutationDeleteNotificationsArgs = {
  ids: Array<Scalars['String']>;
  systemId: Scalars['String'];
};


export type MutationDeleteSystemVisualDesignArgs = {
  id: Scalars['String'];
  systemId: Scalars['String'];
};


export type MutationPreviewNotificationArgs = {
  environmentId: Scalars['String'];
  notification: NotificationInputType;
  previewExtraData?: InputMaybe<PreviewExtraDataInputType>;
  systemId: Scalars['String'];
};


export type MutationSendNotificationArgs = {
  params: SendNotificationParams;
  systemId: Scalars['String'];
};


export type MutationSetSystemSettingsArgs = {
  environmentId: Scalars['String'];
  settings: SystemSettingsGqlInput;
  systemId: Scalars['String'];
};


export type MutationUpdateAudiencesArgs = {
  audiences: Array<AudienceUpdateInputType>;
  systemId: Scalars['String'];
  updateRules: Scalars['Boolean'];
};


export type MutationUpdateNotificationsArgs = {
  environmentId: Scalars['String'];
  notifications: Array<NotificationInputType>;
  skipPublish?: InputMaybe<Scalars['Boolean']>;
  systemId: Scalars['String'];
};


export type MutationUpdateSystemVisualDesignArgs = {
  id: Scalars['String'];
  systemId: Scalars['String'];
  systemVisualDesign: VisualDesignInputType;
};


export type MutationUploadImageArgs = {
  fileData: UploadImageInput;
};


export type MutationUploadImageFromUrlArgs = {
  fileData: UploadImageFromUrlInput;
};

export type Notification = {
  __typename?: 'Notification';
  activeRecipientsNum?: Maybe<Scalars['Int']>;
  allRecipientsNum?: Maybe<Scalars['Int']>;
  audiencesIds?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dependencies?: Maybe<Array<Dependencies>>;
  endUsersIds?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  numericId: Scalars['Float'];
  publishStates?: Maybe<Array<PublishState>>;
  runtimeDescription?: Maybe<Scalars['String']>;
  runtimeTitle?: Maybe<Scalars['String']>;
  systemId: Scalars['String'];
  targetAudience?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserGraphql;
  visualDesignData?: Maybe<Scalars['JSON']>;
  visualDesignTemplate: Scalars['String'];
};

export type NotificationInfo = {
  numericId: Scalars['Float'];
  title: Scalars['String'];
};

export type NotificationInputType = {
  audiencesIds?: InputMaybe<Array<Scalars['String']>>;
  dependencies?: InputMaybe<Array<DependenciesInputType>>;
  endUsersIds?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  numericId?: InputMaybe<Scalars['Float']>;
  publishStates?: InputMaybe<Array<PublishStateInputType>>;
  runtimeDescription?: InputMaybe<Scalars['String']>;
  runtimeTitle?: InputMaybe<Scalars['String']>;
  systemId: Scalars['String'];
  targetAudience?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
  type: Scalars['Int'];
  user: UserInputType;
  visualDesignData?: InputMaybe<Scalars['JSON']>;
  visualDesignTemplate: Scalars['String'];
};

export type NotificationRecurrence = {
  __typename?: 'NotificationRecurrence';
  activePeriod?: Maybe<ActivePeriod>;
  dayRules?: Maybe<DayRules>;
  endRecurrenceButtons?: Maybe<Scalars['JSON']>;
  monthRules?: Maybe<MonthRules>;
  weekRules?: Maybe<WeekRules>;
  yearRules?: Maybe<YearRules>;
};

export type NotificationRecurrenceInputType = {
  activePeriod?: InputMaybe<ActivePeriodInputType>;
  dayRules?: InputMaybe<DayRulesInputType>;
  endRecurrenceButtons?: InputMaybe<Scalars['JSON']>;
  monthRules?: InputMaybe<MonthRulesInputType>;
  weekRules?: InputMaybe<WeekRulesInputType>;
  yearRules?: InputMaybe<YearRulesInputType>;
};

export type NotificationScheduling = {
  __typename?: 'NotificationScheduling';
  audienceTimeZone?: Maybe<NotificationTimeZone>;
  recurrence?: Maybe<NotificationRecurrence>;
};

export type NotificationSchedulingInputType = {
  audienceTimeZone?: InputMaybe<NotificationTimeZoneInputType>;
  recurrence?: InputMaybe<NotificationRecurrenceInputType>;
};

export type NotificationTimeZone = {
  __typename?: 'NotificationTimeZone';
  timezoneOffset: Scalars['Float'];
};

export type NotificationTimeZoneInputType = {
  timezoneOffset: Scalars['Float'];
};

export type NotificationsAverageReceived = {
  __typename?: 'NotificationsAverageReceived';
  notificationRecipientsNumAddedDate?: Maybe<Scalars['DateTime']>;
  recipientsSum?: Maybe<Scalars['Float']>;
};

export type NotificationsCountData = {
  __typename?: 'NotificationsCountData';
  active?: Maybe<Scalars['Float']>;
  archived?: Maybe<Scalars['Float']>;
  drafts?: Maybe<Scalars['Float']>;
  scheduled?: Maybe<Scalars['Float']>;
  sent?: Maybe<Scalars['Float']>;
};

export type NotificationsFiltersFields = {
  __typename?: 'NotificationsFiltersFields';
  active?: Maybe<NotificationsTableFiltersFields>;
  archived?: Maybe<NotificationsTableFiltersFields>;
  drafts?: Maybe<NotificationsTableFiltersFields>;
  scheduled?: Maybe<NotificationsTableFiltersFields>;
  sent?: Maybe<NotificationsTableFiltersFields>;
};

export type NotificationsListData = {
  __typename?: 'NotificationsListData';
  count: Scalars['Float'];
  list: Array<Notification>;
};

export type NotificationsTableFiltersFields = {
  __typename?: 'NotificationsTableFiltersFields';
  audiences?: Maybe<Array<Scalars['String']>>;
  sender?: Maybe<Array<Scalars['String']>>;
};

export type OverrideKeyValue = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Permission = {
  __typename?: 'Permission';
  actionKey: Scalars['String'];
  permission: Scalars['String'];
};

export type PlayableItem = {
  __typename?: 'PlayableItem';
  id: Scalars['Float'];
  isModified: Scalars['Boolean'];
  name: Scalars['String'];
  publishStatus: Scalars['Float'];
  resourceId: Scalars['String'];
  steps?: Maybe<Array<PlayableItemStep>>;
};

export type PlayableItemStep = {
  __typename?: 'PlayableItemStep';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type PlayableItems = {
  __typename?: 'PlayableItems';
  Resource: Array<Scalars['JSON']>;
  Shuttle: Array<Scalars['JSON']>;
  SmartWalkThru: Array<Scalars['JSON']>;
};

export type PreviewExtraDataInputType = {
  ignoreNotificationType?: InputMaybe<Scalars['Boolean']>;
};

export type PreviewNotificationsResult = {
  __typename?: 'PreviewNotificationsResult';
  data: Scalars['String'];
  path: Scalars['String'];
};

export enum PublicApiNotificationTypeEnum {
  Popup = 'popup',
  Push = 'push'
}

export type PublishResult = {
  __typename?: 'PublishResult';
  deleteSettingsResults?: Maybe<Array<Scalars['JSON']>>;
  deleteVisualDesignResults?: Maybe<Array<Scalars['JSON']>>;
  info?: Maybe<Scalars['String']>;
  sendSNSResults?: Maybe<Array<Scalars['JSON']>>;
  writeSettingsDeprecatedResults?: Maybe<Array<Scalars['JSON']>>;
  writeSettingsResults?: Maybe<Array<Scalars['JSON']>>;
  writeSettingsResultsDeprecated?: Maybe<Array<Scalars['JSON']>>;
  writeVisualDesignDeprecatedResults?: Maybe<Array<Scalars['JSON']>>;
  writeVisualDesignResults?: Maybe<Array<Scalars['JSON']>>;
};

export type PublishResultGraphql = {
  __typename?: 'PublishResultGraphql';
  info?: Maybe<Scalars['String']>;
  writeSettingsResults?: Maybe<Scalars['JSON']>;
  writeVisualDesignResults?: Maybe<Scalars['JSON']>;
};

export type PublishState = {
  __typename?: 'PublishState';
  endAt?: Maybe<Scalars['DateTime']>;
  environmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDraft: Scalars['Boolean'];
  isOld: Scalars['Boolean'];
  isPaused: Scalars['Boolean'];
  isScheduled: Scalars['Boolean'];
  notificationId?: Maybe<Scalars['String']>;
  publishStatus?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  scheduling?: Maybe<NotificationScheduling>;
  startAt?: Maybe<Scalars['DateTime']>;
};

export type PublishStateInputType = {
  endAt?: InputMaybe<Scalars['DateTime']>;
  environmentId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  notificationId?: InputMaybe<Scalars['String']>;
  publishStatus?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  scheduling?: InputMaybe<NotificationSchedulingInputType>;
  startAt?: InputMaybe<Scalars['DateTime']>;
};

export type Query = {
  __typename?: 'Query';
  calculateRecipientsList: RecipientsResults;
  calculateRecipientsSizeForFilter: Scalars['Int'];
  getActiveNotifications: NotificationsListData;
  getAllRecipientsData: AllRecipientsData;
  getAnalyticsSummary: AnalyticsSummaryResult;
  getArchivedNotifications: NotificationsListData;
  getAudience: AudienceGraphql;
  getAudienceCombinationRecipientsCount: RecipientsCountResult;
  getAudiencesLists: AudiencesList;
  getCalculateRecipientsSize: RecipientsCountResult;
  getDetailedAnalytics: Array<DetailedAnalyticsResult>;
  getDraftNotifications: NotificationsListData;
  getImages: Array<ImageItem>;
  getIntegrations: SystemIntegrationsGraphql;
  getNotificationAnalytics?: Maybe<DetailedAnalyticsResult>;
  getNotificationById: Notification;
  getNotificationEngagementAnalytics: Array<UsersEngagementAnalyticsResult>;
  getNotificationRecipientsCount: Scalars['Int'];
  getNotificationsAverageReceived: NotificationsAverageReceived;
  getNotificationsCount: NotificationsCountData;
  getNotificationsFiltersFields: NotificationsFiltersFields;
  getPlayableItem?: Maybe<PlayableItem>;
  getPlayableItems?: Maybe<PlayableItems>;
  getRecipients: RecipientsResults;
  getRecipientsAggregations: AggregationsResultsGraphql;
  getRecipientsForAudiencesCombination: RecipientsResults;
  getScheduledNotifications: NotificationsListData;
  getSegments?: Maybe<Array<Scalars['JSON']>>;
  getSentNotifications: NotificationsListData;
  getSystemVisualDesign: SystemVisualDesign;
  getSystemVisualDesigns: Array<SystemVisualDesign>;
  getUserAttributes: Array<UserAttribute>;
  getUserSettings?: Maybe<UserSettings>;
  getUsers?: Maybe<Array<User>>;
  getV2AnalyticsSummary: AnalyticsSummaryResult;
  getV2NotificationAnalytics?: Maybe<DetailedAnalyticsResult>;
};


export type QueryCalculateRecipientsListArgs = {
  query?: InputMaybe<RecipientsListQueryInput>;
  rules: Array<AudienceRuleInputType>;
  systemId: Scalars['String'];
};


export type QueryCalculateRecipientsSizeForFilterArgs = {
  recipientsFilter: CalculateRecipientsForFilterBodyRecipientsFilterEnum;
  rules: Array<AudienceRuleInputType>;
  systemId: Scalars['String'];
};


export type QueryGetActiveNotificationsArgs = {
  environmentId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<GetNotificationsArgsQuery>;
  systemId: Scalars['String'];
};


export type QueryGetAllRecipientsDataArgs = {
  systemId: Scalars['String'];
};


export type QueryGetAnalyticsSummaryArgs = {
  environmentId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
  systemId: Scalars['String'];
};


export type QueryGetArchivedNotificationsArgs = {
  environmentId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<GetNotificationsArgsQuery>;
  systemId: Scalars['String'];
};


export type QueryGetAudienceArgs = {
  audienceId: Scalars['String'];
  systemId: Scalars['String'];
};


export type QueryGetAudienceCombinationRecipientsCountArgs = {
  audienceIds: Array<Scalars['String']>;
  endUsersIds?: InputMaybe<Array<Scalars['String']>>;
  systemId: Scalars['String'];
};


export type QueryGetAudiencesListsArgs = {
  systemId: Scalars['String'];
};


export type QueryGetCalculateRecipientsSizeArgs = {
  rules: Array<AudienceRuleInputType>;
  systemId: Scalars['String'];
};


export type QueryGetDetailedAnalyticsArgs = {
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
};


export type QueryGetDraftNotificationsArgs = {
  environmentId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<GetNotificationsArgsQuery>;
  systemId: Scalars['String'];
};


export type QueryGetImagesArgs = {
  systemId: Scalars['String'];
};


export type QueryGetIntegrationsArgs = {
  realtime?: InputMaybe<Scalars['Boolean']>;
  systemId: Scalars['String'];
};


export type QueryGetNotificationAnalyticsArgs = {
  environmentId: Scalars['String'];
  noDateLimit?: InputMaybe<Scalars['Boolean']>;
  numericId: Scalars['Float'];
  systemId: Scalars['String'];
};


export type QueryGetNotificationByIdArgs = {
  environmentId: Scalars['String'];
  notificationId: Scalars['String'];
  systemId: Scalars['String'];
};


export type QueryGetNotificationEngagementAnalyticsArgs = {
  environmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  noDateLimit?: InputMaybe<Scalars['Boolean']>;
  notificationNumericId: Scalars['Float'];
  searchTerm?: InputMaybe<Scalars['String']>;
  systemId: Scalars['String'];
};


export type QueryGetNotificationRecipientsCountArgs = {
  audienceIds: Array<Scalars['String']>;
  endUsersIds?: InputMaybe<Array<Scalars['String']>>;
  recipientsFilter: RecipientsFilter;
  systemId: Scalars['String'];
};


export type QueryGetNotificationsAverageReceivedArgs = {
  environmentId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
  systemId: Scalars['String'];
};


export type QueryGetNotificationsCountArgs = {
  environmentId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
  systemId: Scalars['String'];
};


export type QueryGetNotificationsFiltersFieldsArgs = {
  environmentId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
  systemId: Scalars['String'];
};


export type QueryGetPlayableItemArgs = {
  params: GetPlayableItemParams;
};


export type QueryGetPlayableItemsArgs = {
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
};


export type QueryGetRecipientsArgs = {
  audienceId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<RecipientsListQueryInput>;
};


export type QueryGetRecipientsAggregationsArgs = {
  filterActiveRecipients?: InputMaybe<Scalars['Boolean']>;
  matrixFilter?: InputMaybe<Scalars['Boolean']>;
  mustIncludeValues?: InputMaybe<Array<Scalars['String']>>;
  properties: Array<AggregateRecipientsBodyPropertyInput>;
  rules: Array<AudienceRuleInputType>;
  systemId: Scalars['String'];
};


export type QueryGetRecipientsForAudiencesCombinationArgs = {
  audiencesIds?: InputMaybe<Array<Scalars['String']>>;
  endUsersIds?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<RecipientsListQueryInput>;
};


export type QueryGetScheduledNotificationsArgs = {
  environmentId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<GetNotificationsArgsQuery>;
  systemId: Scalars['String'];
};


export type QueryGetSegmentsArgs = {
  environmentId: Scalars['String'];
  numericSystemId: Scalars['Float'];
  systemId: Scalars['String'];
};


export type QueryGetSentNotificationsArgs = {
  environmentId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<GetNotificationsArgsQuery>;
  systemId: Scalars['String'];
};


export type QueryGetSystemVisualDesignArgs = {
  id: Scalars['String'];
  systemId: Scalars['String'];
};


export type QueryGetSystemVisualDesignsArgs = {
  systemId: Scalars['String'];
};


export type QueryGetUserAttributesArgs = {
  numericSystemId: Scalars['Float'];
};


export type QueryGetUserSettingsArgs = {
  systemId: Scalars['String'];
};


export type QueryGetV2AnalyticsSummaryArgs = {
  environmentId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
  systemId: Scalars['String'];
};


export type QueryGetV2NotificationAnalyticsArgs = {
  environmentId: Scalars['String'];
  noDateLimit?: InputMaybe<Scalars['Boolean']>;
  numericId: Scalars['Float'];
  systemId: Scalars['String'];
};

export type RecipientsCountResult = {
  __typename?: 'RecipientsCountResult';
  active: Scalars['Int'];
  all: Scalars['Int'];
  inactive: Scalars['Int'];
  potential: Scalars['Int'];
};

export enum RecipientsFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Inactive = 'INACTIVE',
  Potential = 'POTENTIAL'
}

export type RecipientsListQuery = {
  __typename?: 'RecipientsListQuery';
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  recipientsFilter: RecipientsFilter;
  search?: Maybe<Scalars['String']>;
};

export type RecipientsListQueryInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  recipientsFilter: RecipientsFilter;
  search?: InputMaybe<Scalars['String']>;
};

export type RecipientsResults = {
  __typename?: 'RecipientsResults';
  audienceId?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  query: RecipientsListQuery;
  recipients: Array<UserRecipientGraphql>;
};

export type ReportParamsNew = {
  audiences?: InputMaybe<Array<AudienceInfo>>;
  endUsersIds?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<RecipientsFilter>;
  notification?: InputMaybe<NotificationInfo>;
};

export enum ReportTypes {
  Notifications = 'NOTIFICATIONS',
  NotificationEngagement = 'NOTIFICATION_ENGAGEMENT',
  RecipientsList = 'RECIPIENTS_LIST',
  ReportFailed = 'REPORT_FAILED',
  UsersWithoutWs = 'USERS_WITHOUT_WS'
}

export type Role = {
  __typename?: 'Role';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  permissions?: Maybe<Array<Permission>>;
};

export type SendNotificationParams = {
  audiencesIds?: InputMaybe<Array<Scalars['String']>>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  endUsersIds?: InputMaybe<Array<Scalars['String']>>;
  environmentId?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  notificationType?: InputMaybe<PublicApiNotificationTypeEnum>;
  override?: InputMaybe<Array<OverrideKeyValue>>;
  runtimeDescription?: InputMaybe<Scalars['String']>;
  runtimeTitle?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  templateId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type SendNotificationResponse = {
  __typename?: 'SendNotificationResponse';
  info: Scalars['String'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SystemIntegrationsGraphql = {
  __typename?: 'SystemIntegrationsGraphql';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrations: Array<IntegrationGraphql>;
  systemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SystemSettings = {
  __typename?: 'SystemSettings';
  createdAt?: Maybe<Scalars['DateTime']>;
  pollingInterval?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SystemSettingsGqlInput = {
  pollingInterval?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['String']>;
};

export type SystemVisualDesign = {
  __typename?: 'SystemVisualDesign';
  categories?: Maybe<Array<Scalars['String']>>;
  comingSoon?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  previewImage?: Maybe<Scalars['String']>;
  systemId: Scalars['String'];
  tags: Array<VisualDesignTagGraphql>;
  template: Scalars['JSON'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UpdateAudiencesOutput = {
  __typename?: 'UpdateAudiencesOutput';
  audiences: Array<AudienceGraphql>;
  createdIds: Array<Scalars['String']>;
  deletedIds: Array<Scalars['String']>;
  publishResult?: Maybe<PublishResultGraphql>;
  updatedIds: Array<Scalars['String']>;
};

export type UploadImageFromUrlInput = {
  fileName: Scalars['String'];
  url: Scalars['String'];
  userGuid: Scalars['String'];
};

export type UploadImageFromUrlResponseData = {
  __typename?: 'UploadImageFromUrlResponseData';
  size: Scalars['Int'];
  url: Scalars['String'];
};

export type UploadImageInput = {
  fileBase64: Scalars['String'];
  fileName: Scalars['String'];
  fileSize: Scalars['Float'];
  fileType: Scalars['String'];
  name: Scalars['String'];
  userGuid: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  account?: Maybe<Account>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastLoginDate?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  notificationsNumber: Scalars['Float'];
  role?: Maybe<Role>;
  status: Scalars['String'];
};

export type UserAttribute = {
  __typename?: 'UserAttribute';
  name: Scalars['String'];
  regex?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  value: Scalars['String'];
};

export type UserAttributeInput = {
  name: Scalars['String'];
  regex?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  value: Scalars['String'];
};

export type UserGraphql = {
  __typename?: 'UserGraphql';
  email?: Maybe<Scalars['String']>;
  id: Scalars['JSON'];
  impersonator?: Maybe<Scalars['JSON']>;
  isPublicApiUser?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
};

export type UserInputType = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['JSON'];
  impersonator?: InputMaybe<Scalars['JSON']>;
  isPublicApiUser?: InputMaybe<Scalars['Boolean']>;
  label: Scalars['String'];
};

export type UserRecipientGraphql = {
  __typename?: 'UserRecipientGraphql';
  id: Scalars['JSON'];
  label: Scalars['String'];
  lastSeen?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<EndUserResultIntegrations>>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  analyticsSources: AnalyticsSourcesData;
  featureFlags: Scalars['JSON'];
  hasRequiredWorkstation: Scalars['Boolean'];
  settings?: Maybe<Scalars['JSON']>;
};


export type UserSettingsAnalyticsSourcesArgs = {
  environmentId: Scalars['String'];
};


export type UserSettingsFeatureFlagsArgs = {
  isSkipOverride?: InputMaybe<Scalars['Boolean']>;
};


export type UserSettingsHasRequiredWorkstationArgs = {
  environmentId: Scalars['String'];
};

export type UsersEngagementAnalyticsResult = {
  __typename?: 'UsersEngagementAnalyticsResult';
  clicks?: Maybe<Scalars['Float']>;
  receives?: Maybe<Scalars['Float']>;
  targeted?: Maybe<Scalars['Float']>;
  userId: Scalars['String'];
  views?: Maybe<Scalars['Float']>;
};

export type VisualDesignInputType = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  comingSoon?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  previewImage?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<VisualDesignTagOutput>>;
  template?: InputMaybe<Scalars['JSON']>;
};

export type VisualDesignTagGraphql = {
  __typename?: 'VisualDesignTagGraphql';
  count: Scalars['Float'];
  type: Scalars['String'];
};

export type VisualDesignTagOutput = {
  count: Scalars['Float'];
  type: Scalars['String'];
};

export type WeekRules = {
  __typename?: 'WeekRules';
  weeksInMonth?: Maybe<Array<Scalars['Int']>>;
  weeksRepeat?: Maybe<Scalars['Int']>;
};

export type WeekRulesInputType = {
  weeksInMonth?: InputMaybe<Array<Scalars['Int']>>;
  weeksRepeat?: InputMaybe<Scalars['Int']>;
};

export type YearRules = {
  __typename?: 'YearRules';
  yearsRepeat?: Maybe<Scalars['Float']>;
};

export type YearRulesInputType = {
  yearsRepeat?: InputMaybe<Scalars['Float']>;
};

export type GetPlayableItemParams = {
  deployableId: Scalars['Float'];
  environmentId: Scalars['String'];
  resourceId: Scalars['String'];
  systemId: Scalars['String'];
  type: ContentItemType;
};

export type GetDetailedAnalyticsQueryVariables = Exact<{
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
}>;


export type GetDetailedAnalyticsQuery = { __typename?: 'Query', getDetailedAnalytics: Array<{ __typename?: 'DetailedAnalyticsResult', delivered?: number | null, numericId: number, views?: number | null, clicks?: number | null, received?: number | null }> };

export type GetAnalyticsSummaryQueryVariables = Exact<{
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAnalyticsSummaryQuery = { __typename?: 'Query', getAnalyticsSummary: { __typename?: 'AnalyticsSummaryResult', usersReceived: number, usersViewed: number, usersClicks: number, receives: number, views: number, clicks: number } };

export type GetNotificationAnalyticsQueryVariables = Exact<{
  numericId: Scalars['Float'];
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  noDateLimit?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetNotificationAnalyticsQuery = { __typename?: 'Query', getNotificationAnalytics?: { __typename?: 'DetailedAnalyticsResult', targeted?: number | null, numericId: number, views?: number | null, clicks?: number | null, received?: number | null, actionsClicksWithValues?: any | null, delivered?: number | null } | null };

export type GetV2AnalyticsSummaryQueryVariables = Exact<{
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  onlyUserNotifications?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetV2AnalyticsSummaryQuery = { __typename?: 'Query', getV2AnalyticsSummary: { __typename?: 'AnalyticsSummaryResult', usersReceived: number, usersViewed: number, usersClicks: number, receives: number, views: number, clicks: number } };

export type GetNotificationEngagementAnalyticsQueryVariables = Exact<{
  notificationNumericId: Scalars['Float'];
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  noDateLimit?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Float']>;
}>;


export type GetNotificationEngagementAnalyticsQuery = { __typename?: 'Query', getNotificationEngagementAnalytics: Array<{ __typename?: 'UsersEngagementAnalyticsResult', userId: string, views?: number | null, receives?: number | null, targeted?: number | null, clicks?: number | null }> };

export type GetV2NotificationAnalyticsQueryVariables = Exact<{
  numericId: Scalars['Float'];
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  noDateLimit?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetV2NotificationAnalyticsQuery = { __typename?: 'Query', getV2NotificationAnalytics?: { __typename?: 'DetailedAnalyticsResult', targeted?: number | null, numericId: number, views?: number | null, viewsMobile?: number | null, viewsDesktop?: number | null, clicks?: number | null, received?: number | null, actionsClicksWithValues?: any | null, delivered?: number | null } | null };

export type AudienceDataFragment = { __typename?: 'AudienceGraphql', id: string, data?: { __typename?: 'AudienceDataGraphql', color?: string | null, rules: Array<{ __typename?: 'AudienceRuleGraphql', alias?: string | null, dataType?: AudienceRuleDataTypeEnum | null, integrationId?: string | null, property: string, operator?: AudienceRuleOperatorEnum | null, values: Array<{ __typename?: 'IntegrationPropertyValueGraphql', amount?: number | null, name: string }> }> } | null };

export type AudienceFragment = { __typename?: 'AudienceGraphql', title: string, conditionBlockId?: string | null, createdAt: string, description: string, numericId: number, size: number, sizeLastChangedAt?: string | null, sizeTotal?: number | null, sizeTotalLastChangedAt?: string | null, sizeInactive?: number | null, sizeInactiveLastChangedAt?: string | null, sizeLastUpdateAt?: string | null, systemId: string, type?: number | null, updatedAt: string, publishState?: number | null, notificationsNumber?: number | null, notificationsStatus?: any | null, id: string, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null }, data?: { __typename?: 'AudienceDataGraphql', color?: string | null, rules: Array<{ __typename?: 'AudienceRuleGraphql', alias?: string | null, dataType?: AudienceRuleDataTypeEnum | null, integrationId?: string | null, property: string, operator?: AudienceRuleOperatorEnum | null, values: Array<{ __typename?: 'IntegrationPropertyValueGraphql', amount?: number | null, name: string }> }> } | null };

export type UpdateAudiencesMutationVariables = Exact<{
  audiences: Array<AudienceUpdateInputType> | AudienceUpdateInputType;
  updateRules: Scalars['Boolean'];
  systemId: Scalars['String'];
}>;


export type UpdateAudiencesMutation = { __typename?: 'Mutation', updateAudiences: { __typename?: 'UpdateAudiencesOutput', createdIds: Array<string>, updatedIds: Array<string>, deletedIds: Array<string>, audiences: Array<{ __typename?: 'AudienceGraphql', title: string, conditionBlockId?: string | null, createdAt: string, description: string, numericId: number, size: number, sizeLastChangedAt?: string | null, sizeTotal?: number | null, sizeTotalLastChangedAt?: string | null, sizeInactive?: number | null, sizeInactiveLastChangedAt?: string | null, sizeLastUpdateAt?: string | null, systemId: string, type?: number | null, updatedAt: string, publishState?: number | null, notificationsNumber?: number | null, notificationsStatus?: any | null, id: string, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null }, data?: { __typename?: 'AudienceDataGraphql', color?: string | null, rules: Array<{ __typename?: 'AudienceRuleGraphql', alias?: string | null, dataType?: AudienceRuleDataTypeEnum | null, integrationId?: string | null, property: string, operator?: AudienceRuleOperatorEnum | null, values: Array<{ __typename?: 'IntegrationPropertyValueGraphql', amount?: number | null, name: string }> }> } | null }>, publishResult?: { __typename?: 'PublishResultGraphql', writeVisualDesignResults?: any | null, writeSettingsResults?: any | null, info?: string | null } | null } };

export type DeleteAudienceMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  systemId: Scalars['String'];
}>;


export type DeleteAudienceMutation = { __typename?: 'Mutation', deleteAudiences: { __typename?: 'DeleteAudiencesOutput', deletedCount: number, deletedIds: Array<string> } };

export type CreateAudienceMutationVariables = Exact<{
  audience: AudienceCreateInputType;
  systemId: Scalars['String'];
}>;


export type CreateAudienceMutation = { __typename?: 'Mutation', createAudience: { __typename?: 'CreateAudienceOutput', audiences: Array<{ __typename?: 'AudienceGraphql', title: string, conditionBlockId?: string | null, createdAt: string, description: string, numericId: number, size: number, sizeLastChangedAt?: string | null, sizeTotal?: number | null, sizeTotalLastChangedAt?: string | null, sizeInactive?: number | null, sizeInactiveLastChangedAt?: string | null, sizeLastUpdateAt?: string | null, systemId: string, type?: number | null, updatedAt: string, publishState?: number | null, notificationsNumber?: number | null, notificationsStatus?: any | null, id: string, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null }, data?: { __typename?: 'AudienceDataGraphql', color?: string | null, rules: Array<{ __typename?: 'AudienceRuleGraphql', alias?: string | null, dataType?: AudienceRuleDataTypeEnum | null, integrationId?: string | null, property: string, operator?: AudienceRuleOperatorEnum | null, values: Array<{ __typename?: 'IntegrationPropertyValueGraphql', amount?: number | null, name: string }> }> } | null }> } };

export type GetAudiencesListsQueryVariables = Exact<{
  systemId: Scalars['String'];
}>;


export type GetAudiencesListsQuery = { __typename?: 'Query', getAudiencesLists: { __typename?: 'AudiencesList', audiencesList: Array<{ __typename?: 'AudienceGraphql', title: string, conditionBlockId?: string | null, createdAt: string, description: string, numericId: number, size: number, sizeLastChangedAt?: string | null, sizeTotal?: number | null, sizeTotalLastChangedAt?: string | null, sizeInactive?: number | null, sizeInactiveLastChangedAt?: string | null, sizeLastUpdateAt?: string | null, systemId: string, type?: number | null, updatedAt: string, publishState?: number | null, notificationsNumber?: number | null, notificationsStatus?: any | null, id: string, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null }, data?: { __typename?: 'AudienceDataGraphql', color?: string | null, rules: Array<{ __typename?: 'AudienceRuleGraphql', alias?: string | null, dataType?: AudienceRuleDataTypeEnum | null, integrationId?: string | null, property: string, operator?: AudienceRuleOperatorEnum | null, values: Array<{ __typename?: 'IntegrationPropertyValueGraphql', amount?: number | null, name: string }> }> } | null }>, archivedAudiencesList: Array<{ __typename?: 'AudienceGraphql', title: string, conditionBlockId?: string | null, createdAt: string, description: string, numericId: number, size: number, sizeLastChangedAt?: string | null, sizeTotal?: number | null, sizeTotalLastChangedAt?: string | null, sizeInactive?: number | null, sizeInactiveLastChangedAt?: string | null, sizeLastUpdateAt?: string | null, systemId: string, type?: number | null, updatedAt: string, publishState?: number | null, notificationsNumber?: number | null, notificationsStatus?: any | null, id: string, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null }, data?: { __typename?: 'AudienceDataGraphql', color?: string | null, rules: Array<{ __typename?: 'AudienceRuleGraphql', alias?: string | null, dataType?: AudienceRuleDataTypeEnum | null, integrationId?: string | null, property: string, operator?: AudienceRuleOperatorEnum | null, values: Array<{ __typename?: 'IntegrationPropertyValueGraphql', amount?: number | null, name: string }> }> } | null }> } };

export type GetAllRecipientsDataQueryVariables = Exact<{
  systemId: Scalars['String'];
}>;


export type GetAllRecipientsDataQuery = { __typename?: 'Query', getAllRecipientsData: { __typename?: 'AllRecipientsData', notificationsNumber: number, endUsersCount?: number | null, activeEndUsersCount?: number | null, inactiveEndUsersCount?: number | null, potentialEndUsersCount?: number | null, createdAt?: string | null, hasIntegrationData?: boolean | null, maxIdentifierCount?: number | null, updatedAt?: string | null } };

export type GetAudienceDataQueryVariables = Exact<{
  systemId: Scalars['String'];
  audienceId: Scalars['String'];
}>;


export type GetAudienceDataQuery = { __typename?: 'Query', getAudience: { __typename?: 'AudienceGraphql', id: string, data?: { __typename?: 'AudienceDataGraphql', color?: string | null, rules: Array<{ __typename?: 'AudienceRuleGraphql', alias?: string | null, dataType?: AudienceRuleDataTypeEnum | null, integrationId?: string | null, property: string, operator?: AudienceRuleOperatorEnum | null, values: Array<{ __typename?: 'IntegrationPropertyValueGraphql', amount?: number | null, name: string }> }> } | null } };

export type GetIntegrationsQueryVariables = Exact<{
  systemId: Scalars['String'];
  realtime?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetIntegrationsQuery = { __typename?: 'Query', getIntegrations: { __typename?: 'SystemIntegrationsGraphql', id?: string | null, systemId?: string | null, integrations: Array<{ __typename?: 'IntegrationGraphql', id: string, name: string, type?: IntegrationTypeEnum | null, fields: Array<{ __typename?: 'IntegrationFieldGraphql', name: string, alias?: string | null, dataType?: string | null, role?: IntegrationFieldRole | null }>, identifier: { __typename?: 'IntegrationIdentifierGraphql', source: string, destination: string } }> } };

export type PublishStateFragment = { __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null };

export type _NotificationFragment = { __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null };

export type GetNotificationByIdQueryVariables = Exact<{
  notificationId: Scalars['String'];
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
}>;


export type GetNotificationByIdQuery = { __typename?: 'Query', getNotificationById: { __typename?: 'Notification', visualDesignData?: any | null, id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null } };

export type _NotificationsListDataFragment = { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> };

export type GetActiveNotificationsQueryVariables = Exact<{
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  onlyUserNotifications: Scalars['Boolean'];
  query?: InputMaybe<GetNotificationsArgsQuery>;
}>;


export type GetActiveNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> } };

export type GetScheduledNotificationsQueryVariables = Exact<{
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  onlyUserNotifications: Scalars['Boolean'];
  query?: InputMaybe<GetNotificationsArgsQuery>;
}>;


export type GetScheduledNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> } };

export type GetSentNotificationsQueryVariables = Exact<{
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  onlyUserNotifications: Scalars['Boolean'];
  query?: InputMaybe<GetNotificationsArgsQuery>;
}>;


export type GetSentNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> } };

export type GetDraftNotificationsQueryVariables = Exact<{
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  onlyUserNotifications: Scalars['Boolean'];
  query?: InputMaybe<GetNotificationsArgsQuery>;
}>;


export type GetDraftNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> } };

export type GetArchivedNotificationsQueryVariables = Exact<{
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  onlyUserNotifications: Scalars['Boolean'];
  query?: InputMaybe<GetNotificationsArgsQuery>;
}>;


export type GetArchivedNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> } };

export type GetAllNotificationsQueryVariables = Exact<{
  environmentId: Scalars['String'];
  systemId: Scalars['String'];
  onlyUserNotifications: Scalars['Boolean'];
}>;


export type GetAllNotificationsQuery = { __typename?: 'Query', active: { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> }, scheduled: { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> }, sent: { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> }, drafts: { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> }, archived: { __typename?: 'NotificationsListData', count: number, list: Array<{ __typename?: 'Notification', id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }> } };

export type CreateNotificationMutationVariables = Exact<{
  systemId: Scalars['String'];
  environmentId: Scalars['String'];
  notification: NotificationInputType;
  skipPublish?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateNotificationMutation = { __typename?: 'Mutation', createNotification: { __typename?: 'CreateUpdateNotificationsResult', notifications: Array<{ __typename?: 'Notification', visualDesignData?: any | null, id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }>, publishResult?: { __typename?: 'PublishResult', info?: string | null, deleteVisualDesignResults?: Array<any> | null, writeSettingsResults?: Array<any> | null, writeVisualDesignResults?: Array<any> | null, sendSNSResults?: Array<any> | null } | null } };

export type UpdateNotificationsMutationVariables = Exact<{
  systemId: Scalars['String'];
  environmentId: Scalars['String'];
  notifications: Array<NotificationInputType> | NotificationInputType;
  skipPublish?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateNotificationsMutation = { __typename?: 'Mutation', updateNotifications: { __typename?: 'CreateUpdateNotificationsResult', notifications: Array<{ __typename?: 'Notification', visualDesignData?: any | null, id: string, numericId: number, title?: string | null, runtimeTitle?: string | null, runtimeDescription?: string | null, message?: string | null, type: number, visualDesignTemplate: string, targetAudience?: any | null, audiencesIds?: Array<string> | null, endUsersIds?: Array<string> | null, activeRecipientsNum?: number | null, allRecipientsNum?: number | null, systemId: string, createdAt?: any | null, updatedAt?: any | null, user: { __typename?: 'UserGraphql', id: any, label: string, email?: string | null, impersonator?: any | null, isPublicApiUser?: boolean | null }, dependencies?: Array<{ __typename?: 'Dependencies', dependencyId?: any | null, dependencyType?: number | null }> | null, publishStates?: Array<{ __typename?: 'PublishState', id?: string | null, notificationId?: string | null, environmentId?: string | null, publishedAt?: any | null, startAt?: any | null, endAt?: any | null, publishStatus?: number | null, scheduling?: { __typename?: 'NotificationScheduling', audienceTimeZone?: { __typename?: 'NotificationTimeZone', timezoneOffset: number } | null, recurrence?: { __typename?: 'NotificationRecurrence', endRecurrenceButtons?: any | null, activePeriod?: { __typename?: 'ActivePeriod', amount?: number | null, type?: string | null } | null, dayRules?: { __typename?: 'DayRules', daysInMonth?: Array<number> | null, daysInWeek?: Array<number> | null, daysRepeat?: number | null } | null, weekRules?: { __typename?: 'WeekRules', weeksInMonth?: Array<number> | null, weeksRepeat?: number | null } | null, monthRules?: { __typename?: 'MonthRules', monthsInYear?: Array<number> | null, monthsRepeat?: number | null } | null, yearRules?: { __typename?: 'YearRules', yearsRepeat?: number | null } | null } | null } | null }> | null }>, publishResult?: { __typename?: 'PublishResult', info?: string | null, deleteVisualDesignResults?: Array<any> | null, writeSettingsResults?: Array<any> | null, writeVisualDesignResults?: Array<any> | null, sendSNSResults?: Array<any> | null } | null } };

export type DeleteNotificationsMutationVariables = Exact<{
  systemId: Scalars['String'];
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteNotificationsMutation = { __typename?: 'Mutation', deleteNotifications: { __typename?: 'DeleteNotificationsResult', deletedIds: Array<string>, deletedCount: number, publishResult?: { __typename?: 'PublishResult', info?: string | null, deleteVisualDesignResults?: Array<any> | null, writeSettingsResults?: Array<any> | null, writeVisualDesignResults?: Array<any> | null, sendSNSResults?: Array<any> | null } | null } };

export type PreviewNotificationMutationVariables = Exact<{
  systemId: Scalars['String'];
  notification: NotificationInputType;
  environmentId: Scalars['String'];
  previewExtraData?: InputMaybe<PreviewExtraDataInputType>;
}>;


export type PreviewNotificationMutation = { __typename?: 'Mutation', previewNotification: { __typename?: 'PreviewNotificationsResult', data: string, path: string } };

export type GetNotificationsCountQueryVariables = Exact<{
  systemId: Scalars['String'];
  environmentId: Scalars['String'];
  onlyUserNotifications: Scalars['Boolean'];
}>;


export type GetNotificationsCountQuery = { __typename?: 'Query', getNotificationsCount: { __typename?: 'NotificationsCountData', active?: number | null, sent?: number | null, scheduled?: number | null, drafts?: number | null, archived?: number | null } };

export type GetNotificationsFiltersFieldsQueryVariables = Exact<{
  systemId: Scalars['String'];
  environmentId: Scalars['String'];
  onlyUserNotifications: Scalars['Boolean'];
}>;


export type GetNotificationsFiltersFieldsQuery = { __typename?: 'Query', getNotificationsFiltersFields: { __typename?: 'NotificationsFiltersFields', active?: { __typename?: 'NotificationsTableFiltersFields', audiences?: Array<string> | null, sender?: Array<string> | null } | null, scheduled?: { __typename?: 'NotificationsTableFiltersFields', audiences?: Array<string> | null, sender?: Array<string> | null } | null, sent?: { __typename?: 'NotificationsTableFiltersFields', audiences?: Array<string> | null, sender?: Array<string> | null } | null, drafts?: { __typename?: 'NotificationsTableFiltersFields', audiences?: Array<string> | null, sender?: Array<string> | null } | null, archived?: { __typename?: 'NotificationsTableFiltersFields', audiences?: Array<string> | null, sender?: Array<string> | null } | null } };

export type GetNotificationsAverageReceivedQueryVariables = Exact<{
  systemId: Scalars['String'];
  environmentId: Scalars['String'];
  onlyUserNotifications: Scalars['Boolean'];
}>;


export type GetNotificationsAverageReceivedQuery = { __typename?: 'Query', getNotificationsAverageReceived: { __typename?: 'NotificationsAverageReceived', recipientsSum?: number | null, notificationRecipientsNumAddedDate?: any | null } };

export type _RecipientsResultsFragment = { __typename?: 'RecipientsResults', count: number, query: { __typename?: 'RecipientsListQuery', page?: number | null, limit?: number | null, search?: string | null }, recipients: Array<{ __typename?: 'UserRecipientGraphql', id: any, label: string }> };

export type GetRecipientsQueryVariables = Exact<{
  audienceId?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<RecipientsListQueryInput>;
}>;


export type GetRecipientsQuery = { __typename?: 'Query', getRecipients: { __typename?: 'RecipientsResults', audienceId?: string | null, count: number, query: { __typename?: 'RecipientsListQuery', page?: number | null, limit?: number | null, search?: string | null }, recipients: Array<{ __typename?: 'UserRecipientGraphql', id: any, label: string }> } };

export type GetRecipientsForAudiencesCombinationQueryVariables = Exact<{
  audiencesIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  endUsersIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query?: InputMaybe<RecipientsListQueryInput>;
}>;


export type GetRecipientsForAudiencesCombinationQuery = { __typename?: 'Query', getRecipientsForAudiencesCombination: { __typename?: 'RecipientsResults', count: number, query: { __typename?: 'RecipientsListQuery', page?: number | null, limit?: number | null, search?: string | null }, recipients: Array<{ __typename?: 'UserRecipientGraphql', id: any, label: string }> } };

export type UserRecipientAttributesFragment = { __typename?: 'UserRecipientGraphql', lastSeen?: string | null, properties?: Array<{ __typename?: 'EndUserResultIntegrations', property?: string | null, value?: any | null, integrationId?: string | null }> | null };

export type GetRecipientsIncludingInactiveQueryVariables = Exact<{
  query?: InputMaybe<RecipientsListQueryInput>;
}>;


export type GetRecipientsIncludingInactiveQuery = { __typename?: 'Query', getRecipients: { __typename?: 'RecipientsResults', count: number, recipients: Array<{ __typename?: 'UserRecipientGraphql', id: any, label: string, lastSeen?: string | null, properties?: Array<{ __typename?: 'EndUserResultIntegrations', property?: string | null, value?: any | null, integrationId?: string | null }> | null }> } };

export type GetActiveRecipientsAggregationsQueryVariables = Exact<{
  rules: Array<AudienceRuleInputType> | AudienceRuleInputType;
  properties: Array<AggregateRecipientsBodyPropertyInput> | AggregateRecipientsBodyPropertyInput;
  systemId: Scalars['String'];
  mustIncludeValues?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetActiveRecipientsAggregationsQuery = { __typename?: 'Query', getRecipientsAggregations: { __typename?: 'AggregationsResultsGraphql', propertiesAggregations: Array<{ __typename?: 'AggregationResultGraphql', integrationId: string, property: string, size: number, hasMoreValues?: boolean | null, values: Array<{ __typename?: 'AggregationValueGraphql', name: string, amount: number, globalAmount?: number | null }> }> } };

export type GetCalculateRecipientsSizeQueryVariables = Exact<{
  rules: Array<AudienceRuleInputType> | AudienceRuleInputType;
  systemId: Scalars['String'];
}>;


export type GetCalculateRecipientsSizeQuery = { __typename?: 'Query', getCalculateRecipientsSize: { __typename?: 'RecipientsCountResult', all: number, active: number, inactive: number, potential: number } };

export type CalculateRecipientsSizeForFilterQueryVariables = Exact<{
  rules: Array<AudienceRuleInputType> | AudienceRuleInputType;
  systemId: Scalars['String'];
  recipientsFilter: CalculateRecipientsForFilterBodyRecipientsFilterEnum;
}>;


export type CalculateRecipientsSizeForFilterQuery = { __typename?: 'Query', calculateRecipientsSizeForFilter: number };

export type GetNotificationRecipientsCountQueryVariables = Exact<{
  audienceIds: Array<Scalars['String']> | Scalars['String'];
  endUsersIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  systemId: Scalars['String'];
  recipientsFilter: RecipientsFilter;
}>;


export type GetNotificationRecipientsCountQuery = { __typename?: 'Query', getNotificationRecipientsCount: number };

export type GetAudienceCombinationRecipientsCountQueryVariables = Exact<{
  audienceIds: Array<Scalars['String']> | Scalars['String'];
  endUsersIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  systemId: Scalars['String'];
}>;


export type GetAudienceCombinationRecipientsCountQuery = { __typename?: 'Query', getAudienceCombinationRecipientsCount: { __typename?: 'RecipientsCountResult', all: number, active: number, inactive: number, potential: number } };

export type CalculateRecipientsListQueryVariables = Exact<{
  systemId: Scalars['String'];
  query?: InputMaybe<RecipientsListQueryInput>;
  rules: Array<AudienceRuleInputType> | AudienceRuleInputType;
}>;


export type CalculateRecipientsListQuery = { __typename?: 'Query', calculateRecipientsList: { __typename?: 'RecipientsResults', count: number, query: { __typename?: 'RecipientsListQuery', page?: number | null, limit?: number | null, search?: string | null }, recipients: Array<{ __typename?: 'UserRecipientGraphql', id: any, label: string }> } };

export type GetSelectedRecipientsAttributesQueryVariables = Exact<{
  systemId: Scalars['String'];
  query?: InputMaybe<RecipientsListQueryInput>;
  selectedRecipiensRuleArray: Array<AudienceRuleInputType> | AudienceRuleInputType;
}>;


export type GetSelectedRecipientsAttributesQuery = { __typename?: 'Query', calculateRecipientsList: { __typename?: 'RecipientsResults', recipients: Array<{ __typename?: 'UserRecipientGraphql', id: any, label: string, lastSeen?: string | null, properties?: Array<{ __typename?: 'EndUserResultIntegrations', property?: string | null, value?: any | null, integrationId?: string | null }> | null }> } };

export type CreateReportMutationVariables = Exact<{
  note?: InputMaybe<Scalars['String']>;
  recipients: Array<Scalars['String']> | Scalars['String'];
  dateRange?: InputMaybe<DateRange>;
  environmentId: Scalars['String'];
  timezoneOffset: Scalars['Int'];
  reportType: ReportTypes;
  reportParams?: InputMaybe<ReportParamsNew>;
  analyticsSource?: InputMaybe<AnalyticsSource>;
  language: Language;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'CreateReportResult', recordsSent: number } };

export type CreateNotificationEngagementReportMutationVariables = Exact<{
  note?: InputMaybe<Scalars['String']>;
  recipients: Array<Scalars['String']> | Scalars['String'];
  environmentId: Scalars['String'];
  notificationInfo: NotificationInfo;
  language: Language;
}>;


export type CreateNotificationEngagementReportMutation = { __typename?: 'Mutation', createNotificationEngagementReport: boolean };

export type SystemVisualDesignFragmentFragment = { __typename?: 'SystemVisualDesign', id?: string | null, systemId: string, label: string, description?: string | null, template: any, comingSoon?: boolean | null, categories?: Array<string> | null, createdAt?: any | null, updatedAt?: any | null, tags: Array<{ __typename?: 'VisualDesignTagGraphql', type: string, count: number }> };

export type GetSystemVisualDesignsQueryVariables = Exact<{
  systemId: Scalars['String'];
}>;


export type GetSystemVisualDesignsQuery = { __typename?: 'Query', getSystemVisualDesigns: Array<{ __typename?: 'SystemVisualDesign', id?: string | null, systemId: string, label: string, description?: string | null, template: any, comingSoon?: boolean | null, categories?: Array<string> | null, createdAt?: any | null, updatedAt?: any | null, tags: Array<{ __typename?: 'VisualDesignTagGraphql', type: string, count: number }> }> };

export type CreateSystemVisualDesignMutationVariables = Exact<{
  systemId: Scalars['String'];
  systemVisualDesign: VisualDesignInputType;
}>;


export type CreateSystemVisualDesignMutation = { __typename?: 'Mutation', createSystemVisualDesign: { __typename?: 'SystemVisualDesign', id?: string | null, systemId: string, label: string, description?: string | null, template: any, comingSoon?: boolean | null, categories?: Array<string> | null, createdAt?: any | null, updatedAt?: any | null, tags: Array<{ __typename?: 'VisualDesignTagGraphql', type: string, count: number }> } };

export type UpdateSystemVisualDesignMutationVariables = Exact<{
  id: Scalars['String'];
  systemId: Scalars['String'];
  systemVisualDesign: VisualDesignInputType;
}>;


export type UpdateSystemVisualDesignMutation = { __typename?: 'Mutation', updateSystemVisualDesign: { __typename?: 'SystemVisualDesign', id?: string | null, systemId: string, label: string, description?: string | null, template: any, comingSoon?: boolean | null, categories?: Array<string> | null, createdAt?: any | null, updatedAt?: any | null, tags: Array<{ __typename?: 'VisualDesignTagGraphql', type: string, count: number }> } };

export type DeleteSystemVisualDesignMutationVariables = Exact<{
  systemId: Scalars['String'];
  id: Scalars['String'];
}>;


export type DeleteSystemVisualDesignMutation = { __typename?: 'Mutation', deleteSystemVisualDesign: number };

export type GetFeatureFlagsQueryVariables = Exact<{
  systemId: Scalars['String'];
}>;


export type GetFeatureFlagsQuery = { __typename?: 'Query', getUserSettings?: { __typename?: 'UserSettings', featureFlags: any } | null };

export type GetHasRequiredWorkstationQueryVariables = Exact<{
  systemId: Scalars['String'];
  environmentId: Scalars['String'];
}>;


export type GetHasRequiredWorkstationQuery = { __typename?: 'Query', getUserSettings?: { __typename?: 'UserSettings', hasRequiredWorkstation: boolean } | null };

export type GetSettingsQueryVariables = Exact<{
  systemId: Scalars['String'];
}>;


export type GetSettingsQuery = { __typename?: 'Query', getUserSettings?: { __typename?: 'UserSettings', settings?: any | null } | null };

export type GetUseElectronAnalyticsQueryVariables = Exact<{
  systemId: Scalars['String'];
  environmentId: Scalars['String'];
}>;


export type GetUseElectronAnalyticsQuery = { __typename?: 'Query', getUserSettings?: { __typename?: 'UserSettings', analyticsSources: { __typename?: 'AnalyticsSourcesData', useElectronAnalytics: boolean } } | null };

export type GetAnalyticsSourcesQueryVariables = Exact<{
  systemId: Scalars['String'];
  environmentId: Scalars['String'];
}>;


export type GetAnalyticsSourcesQuery = { __typename?: 'Query', getUserSettings?: { __typename?: 'UserSettings', analyticsSources: { __typename?: 'AnalyticsSourcesData', useElectronAnalytics: boolean, hasLegacyAnalytics: boolean, hasWorkstationAnalytics: boolean } } | null };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', getUsers?: Array<{ __typename?: 'User', id: number, lastLoginDate?: string | null, email: string, firstName: string, lastName: string, status: string, notificationsNumber: number, role?: { __typename?: 'Role', displayName: string, id: number } | null }> | null };

export type GetPlayableItemsQueryVariables = Exact<{
  systemId: Scalars['String'];
  environmentId: Scalars['String'];
}>;


export type GetPlayableItemsQuery = { __typename?: 'Query', getPlayableItems?: { __typename?: 'PlayableItems', Resource: Array<any>, Shuttle: Array<any>, SmartWalkThru: Array<any> } | null };

export type GetPlayableItemQueryVariables = Exact<{
  params: GetPlayableItemParams;
}>;


export type GetPlayableItemQuery = { __typename?: 'Query', getPlayableItem?: { __typename?: 'PlayableItem', id: number, name: string, isModified: boolean, resourceId: string, publishStatus: number, steps?: Array<{ __typename?: 'PlayableItemStep', id: number, name: string }> | null } | null };

export type GetImagesQueryVariables = Exact<{
  systemId: Scalars['String'];
}>;


export type GetImagesQuery = { __typename?: 'Query', getImages: Array<{ __typename?: 'ImageItem', name: string, extension: string, lastModified: string, size: number, url: string, isOriginalSrc?: boolean | null }> };

export type UploadImageMutationVariables = Exact<{
  fileData: UploadImageInput;
}>;


export type UploadImageMutation = { __typename?: 'Mutation', uploadImage: string };

export type UploadImageFromUrlMutationVariables = Exact<{
  fileData: UploadImageFromUrlInput;
}>;


export type UploadImageFromUrlMutation = { __typename?: 'Mutation', uploadImageFromUrl: string };

export type DeleteImageMutationVariables = Exact<{
  fileData: DeleteImageInput;
}>;


export type DeleteImageMutation = { __typename?: 'Mutation', deleteImage: string };

export type GetUserAttributesQueryVariables = Exact<{
  numericSystemId: Scalars['Float'];
}>;


export type GetUserAttributesQuery = { __typename?: 'Query', getUserAttributes: Array<{ __typename?: 'UserAttribute', name: string, type: string, value: string, regex?: string | null }> };

export type AddUserAttributesMutationVariables = Exact<{
  userAttribute: UserAttributeInput;
}>;


export type AddUserAttributesMutation = { __typename?: 'Mutation', addUserAttributes: { __typename?: 'AddUserAttributeResponse', status?: string | null, details?: string | null } };

export const AudienceDataFragmentDoc = gql`
    fragment AudienceData on AudienceGraphql {
  id
  data {
    color
    rules {
      alias
      dataType
      integrationId
      property
      values {
        amount
        name
      }
      operator
    }
  }
}
    `;
export const AudienceFragmentDoc = gql`
    fragment Audience on AudienceGraphql {
  ...AudienceData
  title
  conditionBlockId
  createdAt
  description
  numericId
  size
  sizeLastChangedAt
  sizeTotal
  sizeTotalLastChangedAt
  sizeInactive
  sizeInactiveLastChangedAt
  sizeLastUpdateAt
  systemId
  type
  updatedAt
  publishState
  user {
    id
    label
    email
    impersonator
  }
  notificationsNumber
  notificationsStatus
}
    ${AudienceDataFragmentDoc}`;
export const PublishStateFragmentDoc = gql`
    fragment publishState on PublishState {
  id
  notificationId
  environmentId
  publishedAt
  startAt
  endAt
  scheduling {
    audienceTimeZone {
      timezoneOffset
    }
    recurrence {
      activePeriod {
        amount
        type
      }
      dayRules {
        daysInMonth
        daysInWeek
        daysRepeat
      }
      weekRules {
        weeksInMonth
        weeksRepeat
      }
      monthRules {
        monthsInYear
        monthsRepeat
      }
      yearRules {
        yearsRepeat
      }
      endRecurrenceButtons
    }
  }
  publishStatus
}
    `;
export const _NotificationFragmentDoc = gql`
    fragment _Notification on Notification {
  id
  numericId
  title
  runtimeTitle
  runtimeDescription
  message
  type
  visualDesignTemplate
  targetAudience
  audiencesIds
  endUsersIds
  activeRecipientsNum
  allRecipientsNum
  user {
    id
    label
    email
    impersonator
    isPublicApiUser
  }
  systemId
  dependencies {
    dependencyId
    dependencyType
  }
  publishStates {
    ...publishState
  }
  createdAt
  updatedAt
}
    ${PublishStateFragmentDoc}`;
export const _NotificationsListDataFragmentDoc = gql`
    fragment _NotificationsListData on NotificationsListData {
  count
  list {
    ..._Notification
  }
}
    ${_NotificationFragmentDoc}`;
export const _RecipientsResultsFragmentDoc = gql`
    fragment _RecipientsResults on RecipientsResults {
  count
  query {
    page
    limit
    search
  }
  recipients {
    id
    label
  }
}
    `;
export const UserRecipientAttributesFragmentDoc = gql`
    fragment UserRecipientAttributes on UserRecipientGraphql {
  lastSeen
  properties {
    property
    value
    integrationId
  }
}
    `;
export const SystemVisualDesignFragmentFragmentDoc = gql`
    fragment SystemVisualDesignFragment on SystemVisualDesign {
  id
  systemId
  label
  description
  template
  tags {
    type
    count
  }
  comingSoon
  categories
  createdAt
  updatedAt
}
    `;
export const GetDetailedAnalyticsDocument = gql`
    query getDetailedAnalytics($environmentId: String!, $systemId: String!) {
  getDetailedAnalytics(environmentId: $environmentId, systemId: $systemId) {
    delivered
    numericId
    views
    clicks
    received
  }
}
    `;

/**
 * __useGetDetailedAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetDetailedAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailedAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailedAnalyticsQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetDetailedAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetDetailedAnalyticsQuery, GetDetailedAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetailedAnalyticsQuery, GetDetailedAnalyticsQueryVariables>(GetDetailedAnalyticsDocument, options);
      }
export function useGetDetailedAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetailedAnalyticsQuery, GetDetailedAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetailedAnalyticsQuery, GetDetailedAnalyticsQueryVariables>(GetDetailedAnalyticsDocument, options);
        }
export type GetDetailedAnalyticsQueryHookResult = ReturnType<typeof useGetDetailedAnalyticsQuery>;
export type GetDetailedAnalyticsLazyQueryHookResult = ReturnType<typeof useGetDetailedAnalyticsLazyQuery>;
export type GetDetailedAnalyticsQueryResult = Apollo.QueryResult<GetDetailedAnalyticsQuery, GetDetailedAnalyticsQueryVariables>;
export const GetAnalyticsSummaryDocument = gql`
    query getAnalyticsSummary($environmentId: String!, $systemId: String!, $onlyUserNotifications: Boolean) {
  getAnalyticsSummary(
    environmentId: $environmentId
    systemId: $systemId
    onlyUserNotifications: $onlyUserNotifications
  ) {
    usersReceived
    usersViewed
    usersClicks
    receives
    views
    clicks
  }
}
    `;

/**
 * __useGetAnalyticsSummaryQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsSummaryQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *   },
 * });
 */
export function useGetAnalyticsSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>(GetAnalyticsSummaryDocument, options);
      }
export function useGetAnalyticsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>(GetAnalyticsSummaryDocument, options);
        }
export type GetAnalyticsSummaryQueryHookResult = ReturnType<typeof useGetAnalyticsSummaryQuery>;
export type GetAnalyticsSummaryLazyQueryHookResult = ReturnType<typeof useGetAnalyticsSummaryLazyQuery>;
export type GetAnalyticsSummaryQueryResult = Apollo.QueryResult<GetAnalyticsSummaryQuery, GetAnalyticsSummaryQueryVariables>;
export const GetNotificationAnalyticsDocument = gql`
    query getNotificationAnalytics($numericId: Float!, $environmentId: String!, $systemId: String!, $noDateLimit: Boolean) {
  getNotificationAnalytics(
    numericId: $numericId
    environmentId: $environmentId
    systemId: $systemId
    noDateLimit: $noDateLimit
  ) {
    targeted
    numericId
    views
    clicks
    received
    actionsClicksWithValues
    delivered
  }
}
    `;

/**
 * __useGetNotificationAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetNotificationAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationAnalyticsQuery({
 *   variables: {
 *      numericId: // value for 'numericId'
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      noDateLimit: // value for 'noDateLimit'
 *   },
 * });
 */
export function useGetNotificationAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationAnalyticsQuery, GetNotificationAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationAnalyticsQuery, GetNotificationAnalyticsQueryVariables>(GetNotificationAnalyticsDocument, options);
      }
export function useGetNotificationAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationAnalyticsQuery, GetNotificationAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationAnalyticsQuery, GetNotificationAnalyticsQueryVariables>(GetNotificationAnalyticsDocument, options);
        }
export type GetNotificationAnalyticsQueryHookResult = ReturnType<typeof useGetNotificationAnalyticsQuery>;
export type GetNotificationAnalyticsLazyQueryHookResult = ReturnType<typeof useGetNotificationAnalyticsLazyQuery>;
export type GetNotificationAnalyticsQueryResult = Apollo.QueryResult<GetNotificationAnalyticsQuery, GetNotificationAnalyticsQueryVariables>;
export const GetV2AnalyticsSummaryDocument = gql`
    query getV2AnalyticsSummary($environmentId: String!, $systemId: String!, $onlyUserNotifications: Boolean) {
  getV2AnalyticsSummary(
    environmentId: $environmentId
    systemId: $systemId
    onlyUserNotifications: $onlyUserNotifications
  ) {
    usersReceived
    usersViewed
    usersClicks
    receives
    views
    clicks
  }
}
    `;

/**
 * __useGetV2AnalyticsSummaryQuery__
 *
 * To run a query within a React component, call `useGetV2AnalyticsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetV2AnalyticsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetV2AnalyticsSummaryQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *   },
 * });
 */
export function useGetV2AnalyticsSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetV2AnalyticsSummaryQuery, GetV2AnalyticsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetV2AnalyticsSummaryQuery, GetV2AnalyticsSummaryQueryVariables>(GetV2AnalyticsSummaryDocument, options);
      }
export function useGetV2AnalyticsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetV2AnalyticsSummaryQuery, GetV2AnalyticsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetV2AnalyticsSummaryQuery, GetV2AnalyticsSummaryQueryVariables>(GetV2AnalyticsSummaryDocument, options);
        }
export type GetV2AnalyticsSummaryQueryHookResult = ReturnType<typeof useGetV2AnalyticsSummaryQuery>;
export type GetV2AnalyticsSummaryLazyQueryHookResult = ReturnType<typeof useGetV2AnalyticsSummaryLazyQuery>;
export type GetV2AnalyticsSummaryQueryResult = Apollo.QueryResult<GetV2AnalyticsSummaryQuery, GetV2AnalyticsSummaryQueryVariables>;
export const GetNotificationEngagementAnalyticsDocument = gql`
    query getNotificationEngagementAnalytics($notificationNumericId: Float!, $environmentId: String!, $systemId: String!, $noDateLimit: Boolean, $searchTerm: String, $limit: Float) {
  getNotificationEngagementAnalytics(
    notificationNumericId: $notificationNumericId
    environmentId: $environmentId
    systemId: $systemId
    noDateLimit: $noDateLimit
    searchTerm: $searchTerm
    limit: $limit
  ) {
    userId
    views
    receives
    targeted
    clicks
  }
}
    `;

/**
 * __useGetNotificationEngagementAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetNotificationEngagementAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationEngagementAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationEngagementAnalyticsQuery({
 *   variables: {
 *      notificationNumericId: // value for 'notificationNumericId'
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      noDateLimit: // value for 'noDateLimit'
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetNotificationEngagementAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationEngagementAnalyticsQuery, GetNotificationEngagementAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationEngagementAnalyticsQuery, GetNotificationEngagementAnalyticsQueryVariables>(GetNotificationEngagementAnalyticsDocument, options);
      }
export function useGetNotificationEngagementAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationEngagementAnalyticsQuery, GetNotificationEngagementAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationEngagementAnalyticsQuery, GetNotificationEngagementAnalyticsQueryVariables>(GetNotificationEngagementAnalyticsDocument, options);
        }
export type GetNotificationEngagementAnalyticsQueryHookResult = ReturnType<typeof useGetNotificationEngagementAnalyticsQuery>;
export type GetNotificationEngagementAnalyticsLazyQueryHookResult = ReturnType<typeof useGetNotificationEngagementAnalyticsLazyQuery>;
export type GetNotificationEngagementAnalyticsQueryResult = Apollo.QueryResult<GetNotificationEngagementAnalyticsQuery, GetNotificationEngagementAnalyticsQueryVariables>;
export const GetV2NotificationAnalyticsDocument = gql`
    query getV2NotificationAnalytics($numericId: Float!, $environmentId: String!, $systemId: String!, $noDateLimit: Boolean) {
  getV2NotificationAnalytics(
    numericId: $numericId
    environmentId: $environmentId
    systemId: $systemId
    noDateLimit: $noDateLimit
  ) {
    targeted
    numericId
    views
    viewsMobile
    viewsDesktop
    clicks
    received
    actionsClicksWithValues
    delivered
  }
}
    `;

/**
 * __useGetV2NotificationAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetV2NotificationAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetV2NotificationAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetV2NotificationAnalyticsQuery({
 *   variables: {
 *      numericId: // value for 'numericId'
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      noDateLimit: // value for 'noDateLimit'
 *   },
 * });
 */
export function useGetV2NotificationAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetV2NotificationAnalyticsQuery, GetV2NotificationAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetV2NotificationAnalyticsQuery, GetV2NotificationAnalyticsQueryVariables>(GetV2NotificationAnalyticsDocument, options);
      }
export function useGetV2NotificationAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetV2NotificationAnalyticsQuery, GetV2NotificationAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetV2NotificationAnalyticsQuery, GetV2NotificationAnalyticsQueryVariables>(GetV2NotificationAnalyticsDocument, options);
        }
export type GetV2NotificationAnalyticsQueryHookResult = ReturnType<typeof useGetV2NotificationAnalyticsQuery>;
export type GetV2NotificationAnalyticsLazyQueryHookResult = ReturnType<typeof useGetV2NotificationAnalyticsLazyQuery>;
export type GetV2NotificationAnalyticsQueryResult = Apollo.QueryResult<GetV2NotificationAnalyticsQuery, GetV2NotificationAnalyticsQueryVariables>;
export const UpdateAudiencesDocument = gql`
    mutation updateAudiences($audiences: [AudienceUpdateInputType!]!, $updateRules: Boolean!, $systemId: String!) {
  updateAudiences(
    audiences: $audiences
    updateRules: $updateRules
    systemId: $systemId
  ) {
    audiences {
      ...Audience
    }
    createdIds
    updatedIds
    deletedIds
    publishResult {
      writeVisualDesignResults
      writeSettingsResults
      info
    }
  }
}
    ${AudienceFragmentDoc}`;
export type UpdateAudiencesMutationFn = Apollo.MutationFunction<UpdateAudiencesMutation, UpdateAudiencesMutationVariables>;

/**
 * __useUpdateAudiencesMutation__
 *
 * To run a mutation, you first call `useUpdateAudiencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudiencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudiencesMutation, { data, loading, error }] = useUpdateAudiencesMutation({
 *   variables: {
 *      audiences: // value for 'audiences'
 *      updateRules: // value for 'updateRules'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useUpdateAudiencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAudiencesMutation, UpdateAudiencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAudiencesMutation, UpdateAudiencesMutationVariables>(UpdateAudiencesDocument, options);
      }
export type UpdateAudiencesMutationHookResult = ReturnType<typeof useUpdateAudiencesMutation>;
export type UpdateAudiencesMutationResult = Apollo.MutationResult<UpdateAudiencesMutation>;
export type UpdateAudiencesMutationOptions = Apollo.BaseMutationOptions<UpdateAudiencesMutation, UpdateAudiencesMutationVariables>;
export const DeleteAudienceDocument = gql`
    mutation deleteAudience($ids: [String!]!, $systemId: String!) {
  deleteAudiences(ids: $ids, systemId: $systemId) {
    deletedCount
    deletedIds
  }
}
    `;
export type DeleteAudienceMutationFn = Apollo.MutationFunction<DeleteAudienceMutation, DeleteAudienceMutationVariables>;

/**
 * __useDeleteAudienceMutation__
 *
 * To run a mutation, you first call `useDeleteAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAudienceMutation, { data, loading, error }] = useDeleteAudienceMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useDeleteAudienceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAudienceMutation, DeleteAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAudienceMutation, DeleteAudienceMutationVariables>(DeleteAudienceDocument, options);
      }
export type DeleteAudienceMutationHookResult = ReturnType<typeof useDeleteAudienceMutation>;
export type DeleteAudienceMutationResult = Apollo.MutationResult<DeleteAudienceMutation>;
export type DeleteAudienceMutationOptions = Apollo.BaseMutationOptions<DeleteAudienceMutation, DeleteAudienceMutationVariables>;
export const CreateAudienceDocument = gql`
    mutation createAudience($audience: AudienceCreateInputType!, $systemId: String!) {
  createAudience(audience: $audience, systemId: $systemId) {
    audiences {
      ...Audience
    }
  }
}
    ${AudienceFragmentDoc}`;
export type CreateAudienceMutationFn = Apollo.MutationFunction<CreateAudienceMutation, CreateAudienceMutationVariables>;

/**
 * __useCreateAudienceMutation__
 *
 * To run a mutation, you first call `useCreateAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceMutation, { data, loading, error }] = useCreateAudienceMutation({
 *   variables: {
 *      audience: // value for 'audience'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useCreateAudienceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAudienceMutation, CreateAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAudienceMutation, CreateAudienceMutationVariables>(CreateAudienceDocument, options);
      }
export type CreateAudienceMutationHookResult = ReturnType<typeof useCreateAudienceMutation>;
export type CreateAudienceMutationResult = Apollo.MutationResult<CreateAudienceMutation>;
export type CreateAudienceMutationOptions = Apollo.BaseMutationOptions<CreateAudienceMutation, CreateAudienceMutationVariables>;
export const GetAudiencesListsDocument = gql`
    query getAudiencesLists($systemId: String!) {
  getAudiencesLists(systemId: $systemId) {
    audiencesList {
      ...Audience
    }
    archivedAudiencesList {
      ...Audience
    }
  }
}
    ${AudienceFragmentDoc}`;

/**
 * __useGetAudiencesListsQuery__
 *
 * To run a query within a React component, call `useGetAudiencesListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudiencesListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudiencesListsQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetAudiencesListsQuery(baseOptions: Apollo.QueryHookOptions<GetAudiencesListsQuery, GetAudiencesListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAudiencesListsQuery, GetAudiencesListsQueryVariables>(GetAudiencesListsDocument, options);
      }
export function useGetAudiencesListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAudiencesListsQuery, GetAudiencesListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAudiencesListsQuery, GetAudiencesListsQueryVariables>(GetAudiencesListsDocument, options);
        }
export type GetAudiencesListsQueryHookResult = ReturnType<typeof useGetAudiencesListsQuery>;
export type GetAudiencesListsLazyQueryHookResult = ReturnType<typeof useGetAudiencesListsLazyQuery>;
export type GetAudiencesListsQueryResult = Apollo.QueryResult<GetAudiencesListsQuery, GetAudiencesListsQueryVariables>;
export const GetAllRecipientsDataDocument = gql`
    query getAllRecipientsData($systemId: String!) {
  getAllRecipientsData(systemId: $systemId) {
    notificationsNumber
    endUsersCount
    activeEndUsersCount
    inactiveEndUsersCount
    potentialEndUsersCount
    createdAt
    hasIntegrationData
    maxIdentifierCount
    updatedAt
  }
}
    `;

/**
 * __useGetAllRecipientsDataQuery__
 *
 * To run a query within a React component, call `useGetAllRecipientsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRecipientsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRecipientsDataQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetAllRecipientsDataQuery(baseOptions: Apollo.QueryHookOptions<GetAllRecipientsDataQuery, GetAllRecipientsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRecipientsDataQuery, GetAllRecipientsDataQueryVariables>(GetAllRecipientsDataDocument, options);
      }
export function useGetAllRecipientsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRecipientsDataQuery, GetAllRecipientsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRecipientsDataQuery, GetAllRecipientsDataQueryVariables>(GetAllRecipientsDataDocument, options);
        }
export type GetAllRecipientsDataQueryHookResult = ReturnType<typeof useGetAllRecipientsDataQuery>;
export type GetAllRecipientsDataLazyQueryHookResult = ReturnType<typeof useGetAllRecipientsDataLazyQuery>;
export type GetAllRecipientsDataQueryResult = Apollo.QueryResult<GetAllRecipientsDataQuery, GetAllRecipientsDataQueryVariables>;
export const GetAudienceDataDocument = gql`
    query getAudienceData($systemId: String!, $audienceId: String!) {
  getAudience(systemId: $systemId, audienceId: $audienceId) {
    ...AudienceData
  }
}
    ${AudienceDataFragmentDoc}`;

/**
 * __useGetAudienceDataQuery__
 *
 * To run a query within a React component, call `useGetAudienceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceDataQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useGetAudienceDataQuery(baseOptions: Apollo.QueryHookOptions<GetAudienceDataQuery, GetAudienceDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAudienceDataQuery, GetAudienceDataQueryVariables>(GetAudienceDataDocument, options);
      }
export function useGetAudienceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAudienceDataQuery, GetAudienceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAudienceDataQuery, GetAudienceDataQueryVariables>(GetAudienceDataDocument, options);
        }
export type GetAudienceDataQueryHookResult = ReturnType<typeof useGetAudienceDataQuery>;
export type GetAudienceDataLazyQueryHookResult = ReturnType<typeof useGetAudienceDataLazyQuery>;
export type GetAudienceDataQueryResult = Apollo.QueryResult<GetAudienceDataQuery, GetAudienceDataQueryVariables>;
export const GetIntegrationsDocument = gql`
    query getIntegrations($systemId: String!, $realtime: Boolean) {
  getIntegrations(systemId: $systemId, realtime: $realtime) {
    id
    systemId
    integrations {
      id
      name
      type
      fields {
        name
        alias
        dataType
        role
      }
      identifier {
        source
        destination
      }
    }
  }
}
    `;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      realtime: // value for 'realtime'
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const GetNotificationByIdDocument = gql`
    query getNotificationById($notificationId: String!, $environmentId: String!, $systemId: String!) {
  getNotificationById(
    notificationId: $notificationId
    environmentId: $environmentId
    systemId: $systemId
  ) {
    ..._Notification
    visualDesignData
  }
}
    ${_NotificationFragmentDoc}`;

/**
 * __useGetNotificationByIdQuery__
 *
 * To run a query within a React component, call `useGetNotificationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationByIdQuery({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetNotificationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationByIdQuery, GetNotificationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationByIdQuery, GetNotificationByIdQueryVariables>(GetNotificationByIdDocument, options);
      }
export function useGetNotificationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationByIdQuery, GetNotificationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationByIdQuery, GetNotificationByIdQueryVariables>(GetNotificationByIdDocument, options);
        }
export type GetNotificationByIdQueryHookResult = ReturnType<typeof useGetNotificationByIdQuery>;
export type GetNotificationByIdLazyQueryHookResult = ReturnType<typeof useGetNotificationByIdLazyQuery>;
export type GetNotificationByIdQueryResult = Apollo.QueryResult<GetNotificationByIdQuery, GetNotificationByIdQueryVariables>;
export const GetActiveNotificationsDocument = gql`
    query getActiveNotifications($environmentId: String!, $systemId: String!, $onlyUserNotifications: Boolean!, $query: GetNotificationsArgsQuery) {
  notifications: getActiveNotifications(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
    query: $query
  ) {
    ..._NotificationsListData
  }
}
    ${_NotificationsListDataFragmentDoc}`;

/**
 * __useGetActiveNotificationsQuery__
 *
 * To run a query within a React component, call `useGetActiveNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveNotificationsQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetActiveNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveNotificationsQuery, GetActiveNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveNotificationsQuery, GetActiveNotificationsQueryVariables>(GetActiveNotificationsDocument, options);
      }
export function useGetActiveNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveNotificationsQuery, GetActiveNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveNotificationsQuery, GetActiveNotificationsQueryVariables>(GetActiveNotificationsDocument, options);
        }
export type GetActiveNotificationsQueryHookResult = ReturnType<typeof useGetActiveNotificationsQuery>;
export type GetActiveNotificationsLazyQueryHookResult = ReturnType<typeof useGetActiveNotificationsLazyQuery>;
export type GetActiveNotificationsQueryResult = Apollo.QueryResult<GetActiveNotificationsQuery, GetActiveNotificationsQueryVariables>;
export const GetScheduledNotificationsDocument = gql`
    query getScheduledNotifications($environmentId: String!, $systemId: String!, $onlyUserNotifications: Boolean!, $query: GetNotificationsArgsQuery) {
  notifications: getScheduledNotifications(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
    query: $query
  ) {
    ..._NotificationsListData
  }
}
    ${_NotificationsListDataFragmentDoc}`;

/**
 * __useGetScheduledNotificationsQuery__
 *
 * To run a query within a React component, call `useGetScheduledNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledNotificationsQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetScheduledNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>(GetScheduledNotificationsDocument, options);
      }
export function useGetScheduledNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>(GetScheduledNotificationsDocument, options);
        }
export type GetScheduledNotificationsQueryHookResult = ReturnType<typeof useGetScheduledNotificationsQuery>;
export type GetScheduledNotificationsLazyQueryHookResult = ReturnType<typeof useGetScheduledNotificationsLazyQuery>;
export type GetScheduledNotificationsQueryResult = Apollo.QueryResult<GetScheduledNotificationsQuery, GetScheduledNotificationsQueryVariables>;
export const GetSentNotificationsDocument = gql`
    query getSentNotifications($environmentId: String!, $systemId: String!, $onlyUserNotifications: Boolean!, $query: GetNotificationsArgsQuery) {
  notifications: getSentNotifications(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
    query: $query
  ) {
    ..._NotificationsListData
  }
}
    ${_NotificationsListDataFragmentDoc}`;

/**
 * __useGetSentNotificationsQuery__
 *
 * To run a query within a React component, call `useGetSentNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSentNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSentNotificationsQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetSentNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetSentNotificationsQuery, GetSentNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSentNotificationsQuery, GetSentNotificationsQueryVariables>(GetSentNotificationsDocument, options);
      }
export function useGetSentNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSentNotificationsQuery, GetSentNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSentNotificationsQuery, GetSentNotificationsQueryVariables>(GetSentNotificationsDocument, options);
        }
export type GetSentNotificationsQueryHookResult = ReturnType<typeof useGetSentNotificationsQuery>;
export type GetSentNotificationsLazyQueryHookResult = ReturnType<typeof useGetSentNotificationsLazyQuery>;
export type GetSentNotificationsQueryResult = Apollo.QueryResult<GetSentNotificationsQuery, GetSentNotificationsQueryVariables>;
export const GetDraftNotificationsDocument = gql`
    query getDraftNotifications($environmentId: String!, $systemId: String!, $onlyUserNotifications: Boolean!, $query: GetNotificationsArgsQuery) {
  notifications: getDraftNotifications(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
    query: $query
  ) {
    ..._NotificationsListData
  }
}
    ${_NotificationsListDataFragmentDoc}`;

/**
 * __useGetDraftNotificationsQuery__
 *
 * To run a query within a React component, call `useGetDraftNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftNotificationsQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetDraftNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetDraftNotificationsQuery, GetDraftNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDraftNotificationsQuery, GetDraftNotificationsQueryVariables>(GetDraftNotificationsDocument, options);
      }
export function useGetDraftNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDraftNotificationsQuery, GetDraftNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDraftNotificationsQuery, GetDraftNotificationsQueryVariables>(GetDraftNotificationsDocument, options);
        }
export type GetDraftNotificationsQueryHookResult = ReturnType<typeof useGetDraftNotificationsQuery>;
export type GetDraftNotificationsLazyQueryHookResult = ReturnType<typeof useGetDraftNotificationsLazyQuery>;
export type GetDraftNotificationsQueryResult = Apollo.QueryResult<GetDraftNotificationsQuery, GetDraftNotificationsQueryVariables>;
export const GetArchivedNotificationsDocument = gql`
    query getArchivedNotifications($environmentId: String!, $systemId: String!, $onlyUserNotifications: Boolean!, $query: GetNotificationsArgsQuery) {
  notifications: getArchivedNotifications(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
    query: $query
  ) {
    ..._NotificationsListData
  }
}
    ${_NotificationsListDataFragmentDoc}`;

/**
 * __useGetArchivedNotificationsQuery__
 *
 * To run a query within a React component, call `useGetArchivedNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedNotificationsQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetArchivedNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetArchivedNotificationsQuery, GetArchivedNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivedNotificationsQuery, GetArchivedNotificationsQueryVariables>(GetArchivedNotificationsDocument, options);
      }
export function useGetArchivedNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivedNotificationsQuery, GetArchivedNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivedNotificationsQuery, GetArchivedNotificationsQueryVariables>(GetArchivedNotificationsDocument, options);
        }
export type GetArchivedNotificationsQueryHookResult = ReturnType<typeof useGetArchivedNotificationsQuery>;
export type GetArchivedNotificationsLazyQueryHookResult = ReturnType<typeof useGetArchivedNotificationsLazyQuery>;
export type GetArchivedNotificationsQueryResult = Apollo.QueryResult<GetArchivedNotificationsQuery, GetArchivedNotificationsQueryVariables>;
export const GetAllNotificationsDocument = gql`
    query getAllNotifications($environmentId: String!, $systemId: String!, $onlyUserNotifications: Boolean!) {
  active: getActiveNotifications(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
  ) {
    ..._NotificationsListData
  }
  scheduled: getScheduledNotifications(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
  ) {
    ..._NotificationsListData
  }
  sent: getSentNotifications(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
  ) {
    ..._NotificationsListData
  }
  drafts: getDraftNotifications(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
  ) {
    ..._NotificationsListData
  }
  archived: getArchivedNotifications(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
  ) {
    ..._NotificationsListData
  }
}
    ${_NotificationsListDataFragmentDoc}`;

/**
 * __useGetAllNotificationsQuery__
 *
 * To run a query within a React component, call `useGetAllNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNotificationsQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      systemId: // value for 'systemId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *   },
 * });
 */
export function useGetAllNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetAllNotificationsQuery, GetAllNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNotificationsQuery, GetAllNotificationsQueryVariables>(GetAllNotificationsDocument, options);
      }
export function useGetAllNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNotificationsQuery, GetAllNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNotificationsQuery, GetAllNotificationsQueryVariables>(GetAllNotificationsDocument, options);
        }
export type GetAllNotificationsQueryHookResult = ReturnType<typeof useGetAllNotificationsQuery>;
export type GetAllNotificationsLazyQueryHookResult = ReturnType<typeof useGetAllNotificationsLazyQuery>;
export type GetAllNotificationsQueryResult = Apollo.QueryResult<GetAllNotificationsQuery, GetAllNotificationsQueryVariables>;
export const CreateNotificationDocument = gql`
    mutation createNotification($systemId: String!, $environmentId: String!, $notification: NotificationInputType!, $skipPublish: Boolean) {
  createNotification(
    systemId: $systemId
    environmentId: $environmentId
    notification: $notification
    skipPublish: $skipPublish
  ) {
    notifications {
      ..._Notification
      visualDesignData
    }
    publishResult {
      info
      deleteVisualDesignResults
      writeSettingsResults
      writeVisualDesignResults
      sendSNSResults
    }
  }
}
    ${_NotificationFragmentDoc}`;
export type CreateNotificationMutationFn = Apollo.MutationFunction<CreateNotificationMutation, CreateNotificationMutationVariables>;

/**
 * __useCreateNotificationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationMutation, { data, loading, error }] = useCreateNotificationMutation({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      environmentId: // value for 'environmentId'
 *      notification: // value for 'notification'
 *      skipPublish: // value for 'skipPublish'
 *   },
 * });
 */
export function useCreateNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationMutation, CreateNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationMutation, CreateNotificationMutationVariables>(CreateNotificationDocument, options);
      }
export type CreateNotificationMutationHookResult = ReturnType<typeof useCreateNotificationMutation>;
export type CreateNotificationMutationResult = Apollo.MutationResult<CreateNotificationMutation>;
export type CreateNotificationMutationOptions = Apollo.BaseMutationOptions<CreateNotificationMutation, CreateNotificationMutationVariables>;
export const UpdateNotificationsDocument = gql`
    mutation updateNotifications($systemId: String!, $environmentId: String!, $notifications: [NotificationInputType!]!, $skipPublish: Boolean) {
  updateNotifications(
    systemId: $systemId
    notifications: $notifications
    environmentId: $environmentId
    skipPublish: $skipPublish
  ) {
    notifications {
      ..._Notification
      visualDesignData
    }
    publishResult {
      info
      deleteVisualDesignResults
      writeSettingsResults
      writeVisualDesignResults
      sendSNSResults
    }
  }
}
    ${_NotificationFragmentDoc}`;
export type UpdateNotificationsMutationFn = Apollo.MutationFunction<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>;

/**
 * __useUpdateNotificationsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsMutation, { data, loading, error }] = useUpdateNotificationsMutation({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      environmentId: // value for 'environmentId'
 *      notifications: // value for 'notifications'
 *      skipPublish: // value for 'skipPublish'
 *   },
 * });
 */
export function useUpdateNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>(UpdateNotificationsDocument, options);
      }
export type UpdateNotificationsMutationHookResult = ReturnType<typeof useUpdateNotificationsMutation>;
export type UpdateNotificationsMutationResult = Apollo.MutationResult<UpdateNotificationsMutation>;
export type UpdateNotificationsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>;
export const DeleteNotificationsDocument = gql`
    mutation deleteNotifications($systemId: String!, $ids: [String!]!) {
  deleteNotifications(systemId: $systemId, ids: $ids) {
    deletedIds
    deletedCount
    publishResult {
      info
      deleteVisualDesignResults
      writeSettingsResults
      writeVisualDesignResults
      sendSNSResults
    }
  }
}
    `;
export type DeleteNotificationsMutationFn = Apollo.MutationFunction<DeleteNotificationsMutation, DeleteNotificationsMutationVariables>;

/**
 * __useDeleteNotificationsMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationsMutation, { data, loading, error }] = useDeleteNotificationsMutation({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationsMutation, DeleteNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationsMutation, DeleteNotificationsMutationVariables>(DeleteNotificationsDocument, options);
      }
export type DeleteNotificationsMutationHookResult = ReturnType<typeof useDeleteNotificationsMutation>;
export type DeleteNotificationsMutationResult = Apollo.MutationResult<DeleteNotificationsMutation>;
export type DeleteNotificationsMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationsMutation, DeleteNotificationsMutationVariables>;
export const PreviewNotificationDocument = gql`
    mutation previewNotification($systemId: String!, $notification: NotificationInputType!, $environmentId: String!, $previewExtraData: PreviewExtraDataInputType) {
  previewNotification(
    systemId: $systemId
    notification: $notification
    environmentId: $environmentId
    previewExtraData: $previewExtraData
  ) {
    data
    path
  }
}
    `;
export type PreviewNotificationMutationFn = Apollo.MutationFunction<PreviewNotificationMutation, PreviewNotificationMutationVariables>;

/**
 * __usePreviewNotificationMutation__
 *
 * To run a mutation, you first call `usePreviewNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewNotificationMutation, { data, loading, error }] = usePreviewNotificationMutation({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      notification: // value for 'notification'
 *      environmentId: // value for 'environmentId'
 *      previewExtraData: // value for 'previewExtraData'
 *   },
 * });
 */
export function usePreviewNotificationMutation(baseOptions?: Apollo.MutationHookOptions<PreviewNotificationMutation, PreviewNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewNotificationMutation, PreviewNotificationMutationVariables>(PreviewNotificationDocument, options);
      }
export type PreviewNotificationMutationHookResult = ReturnType<typeof usePreviewNotificationMutation>;
export type PreviewNotificationMutationResult = Apollo.MutationResult<PreviewNotificationMutation>;
export type PreviewNotificationMutationOptions = Apollo.BaseMutationOptions<PreviewNotificationMutation, PreviewNotificationMutationVariables>;
export const GetNotificationsCountDocument = gql`
    query getNotificationsCount($systemId: String!, $environmentId: String!, $onlyUserNotifications: Boolean!) {
  getNotificationsCount(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
  ) {
    active
    sent
    scheduled
    drafts
    archived
  }
}
    `;

/**
 * __useGetNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsCountQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      environmentId: // value for 'environmentId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *   },
 * });
 */
export function useGetNotificationsCountQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsCountQuery, GetNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsCountQuery, GetNotificationsCountQueryVariables>(GetNotificationsCountDocument, options);
      }
export function useGetNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsCountQuery, GetNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsCountQuery, GetNotificationsCountQueryVariables>(GetNotificationsCountDocument, options);
        }
export type GetNotificationsCountQueryHookResult = ReturnType<typeof useGetNotificationsCountQuery>;
export type GetNotificationsCountLazyQueryHookResult = ReturnType<typeof useGetNotificationsCountLazyQuery>;
export type GetNotificationsCountQueryResult = Apollo.QueryResult<GetNotificationsCountQuery, GetNotificationsCountQueryVariables>;
export const GetNotificationsFiltersFieldsDocument = gql`
    query getNotificationsFiltersFields($systemId: String!, $environmentId: String!, $onlyUserNotifications: Boolean!) {
  getNotificationsFiltersFields(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
  ) {
    active {
      audiences
      sender
    }
    scheduled {
      audiences
      sender
    }
    sent {
      audiences
      sender
    }
    drafts {
      audiences
      sender
    }
    archived {
      audiences
      sender
    }
  }
}
    `;

/**
 * __useGetNotificationsFiltersFieldsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsFiltersFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsFiltersFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsFiltersFieldsQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      environmentId: // value for 'environmentId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *   },
 * });
 */
export function useGetNotificationsFiltersFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsFiltersFieldsQuery, GetNotificationsFiltersFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsFiltersFieldsQuery, GetNotificationsFiltersFieldsQueryVariables>(GetNotificationsFiltersFieldsDocument, options);
      }
export function useGetNotificationsFiltersFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsFiltersFieldsQuery, GetNotificationsFiltersFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsFiltersFieldsQuery, GetNotificationsFiltersFieldsQueryVariables>(GetNotificationsFiltersFieldsDocument, options);
        }
export type GetNotificationsFiltersFieldsQueryHookResult = ReturnType<typeof useGetNotificationsFiltersFieldsQuery>;
export type GetNotificationsFiltersFieldsLazyQueryHookResult = ReturnType<typeof useGetNotificationsFiltersFieldsLazyQuery>;
export type GetNotificationsFiltersFieldsQueryResult = Apollo.QueryResult<GetNotificationsFiltersFieldsQuery, GetNotificationsFiltersFieldsQueryVariables>;
export const GetNotificationsAverageReceivedDocument = gql`
    query getNotificationsAverageReceived($systemId: String!, $environmentId: String!, $onlyUserNotifications: Boolean!) {
  getNotificationsAverageReceived(
    systemId: $systemId
    environmentId: $environmentId
    onlyUserNotifications: $onlyUserNotifications
  ) {
    recipientsSum
    notificationRecipientsNumAddedDate
  }
}
    `;

/**
 * __useGetNotificationsAverageReceivedQuery__
 *
 * To run a query within a React component, call `useGetNotificationsAverageReceivedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsAverageReceivedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsAverageReceivedQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      environmentId: // value for 'environmentId'
 *      onlyUserNotifications: // value for 'onlyUserNotifications'
 *   },
 * });
 */
export function useGetNotificationsAverageReceivedQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsAverageReceivedQuery, GetNotificationsAverageReceivedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsAverageReceivedQuery, GetNotificationsAverageReceivedQueryVariables>(GetNotificationsAverageReceivedDocument, options);
      }
export function useGetNotificationsAverageReceivedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsAverageReceivedQuery, GetNotificationsAverageReceivedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsAverageReceivedQuery, GetNotificationsAverageReceivedQueryVariables>(GetNotificationsAverageReceivedDocument, options);
        }
export type GetNotificationsAverageReceivedQueryHookResult = ReturnType<typeof useGetNotificationsAverageReceivedQuery>;
export type GetNotificationsAverageReceivedLazyQueryHookResult = ReturnType<typeof useGetNotificationsAverageReceivedLazyQuery>;
export type GetNotificationsAverageReceivedQueryResult = Apollo.QueryResult<GetNotificationsAverageReceivedQuery, GetNotificationsAverageReceivedQueryVariables>;
export const GetRecipientsDocument = gql`
    query getRecipients($audienceId: String, $query: RecipientsListQueryInput) {
  getRecipients(audienceId: $audienceId, query: $query) {
    audienceId
    ..._RecipientsResults
  }
}
    ${_RecipientsResultsFragmentDoc}`;

/**
 * __useGetRecipientsQuery__
 *
 * To run a query within a React component, call `useGetRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipientsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecipientsQuery, GetRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecipientsQuery, GetRecipientsQueryVariables>(GetRecipientsDocument, options);
      }
export function useGetRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipientsQuery, GetRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecipientsQuery, GetRecipientsQueryVariables>(GetRecipientsDocument, options);
        }
export type GetRecipientsQueryHookResult = ReturnType<typeof useGetRecipientsQuery>;
export type GetRecipientsLazyQueryHookResult = ReturnType<typeof useGetRecipientsLazyQuery>;
export type GetRecipientsQueryResult = Apollo.QueryResult<GetRecipientsQuery, GetRecipientsQueryVariables>;
export const GetRecipientsForAudiencesCombinationDocument = gql`
    query getRecipientsForAudiencesCombination($audiencesIds: [String!], $endUsersIds: [String!], $query: RecipientsListQueryInput) {
  getRecipientsForAudiencesCombination(
    audiencesIds: $audiencesIds
    endUsersIds: $endUsersIds
    query: $query
  ) {
    ..._RecipientsResults
  }
}
    ${_RecipientsResultsFragmentDoc}`;

/**
 * __useGetRecipientsForAudiencesCombinationQuery__
 *
 * To run a query within a React component, call `useGetRecipientsForAudiencesCombinationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipientsForAudiencesCombinationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipientsForAudiencesCombinationQuery({
 *   variables: {
 *      audiencesIds: // value for 'audiencesIds'
 *      endUsersIds: // value for 'endUsersIds'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetRecipientsForAudiencesCombinationQuery(baseOptions?: Apollo.QueryHookOptions<GetRecipientsForAudiencesCombinationQuery, GetRecipientsForAudiencesCombinationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecipientsForAudiencesCombinationQuery, GetRecipientsForAudiencesCombinationQueryVariables>(GetRecipientsForAudiencesCombinationDocument, options);
      }
export function useGetRecipientsForAudiencesCombinationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipientsForAudiencesCombinationQuery, GetRecipientsForAudiencesCombinationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecipientsForAudiencesCombinationQuery, GetRecipientsForAudiencesCombinationQueryVariables>(GetRecipientsForAudiencesCombinationDocument, options);
        }
export type GetRecipientsForAudiencesCombinationQueryHookResult = ReturnType<typeof useGetRecipientsForAudiencesCombinationQuery>;
export type GetRecipientsForAudiencesCombinationLazyQueryHookResult = ReturnType<typeof useGetRecipientsForAudiencesCombinationLazyQuery>;
export type GetRecipientsForAudiencesCombinationQueryResult = Apollo.QueryResult<GetRecipientsForAudiencesCombinationQuery, GetRecipientsForAudiencesCombinationQueryVariables>;
export const GetRecipientsIncludingInactiveDocument = gql`
    query getRecipientsIncludingInactive($query: RecipientsListQueryInput) {
  getRecipients(query: $query) {
    count
    recipients {
      id
      label
      ...UserRecipientAttributes
    }
  }
}
    ${UserRecipientAttributesFragmentDoc}`;

/**
 * __useGetRecipientsIncludingInactiveQuery__
 *
 * To run a query within a React component, call `useGetRecipientsIncludingInactiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipientsIncludingInactiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipientsIncludingInactiveQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetRecipientsIncludingInactiveQuery(baseOptions?: Apollo.QueryHookOptions<GetRecipientsIncludingInactiveQuery, GetRecipientsIncludingInactiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecipientsIncludingInactiveQuery, GetRecipientsIncludingInactiveQueryVariables>(GetRecipientsIncludingInactiveDocument, options);
      }
export function useGetRecipientsIncludingInactiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipientsIncludingInactiveQuery, GetRecipientsIncludingInactiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecipientsIncludingInactiveQuery, GetRecipientsIncludingInactiveQueryVariables>(GetRecipientsIncludingInactiveDocument, options);
        }
export type GetRecipientsIncludingInactiveQueryHookResult = ReturnType<typeof useGetRecipientsIncludingInactiveQuery>;
export type GetRecipientsIncludingInactiveLazyQueryHookResult = ReturnType<typeof useGetRecipientsIncludingInactiveLazyQuery>;
export type GetRecipientsIncludingInactiveQueryResult = Apollo.QueryResult<GetRecipientsIncludingInactiveQuery, GetRecipientsIncludingInactiveQueryVariables>;
export const GetActiveRecipientsAggregationsDocument = gql`
    query getActiveRecipientsAggregations($rules: [AudienceRuleInputType!]!, $properties: [AggregateRecipientsBodyPropertyInput!]!, $systemId: String!, $mustIncludeValues: [String!]) {
  getRecipientsAggregations(
    systemId: $systemId
    rules: $rules
    properties: $properties
    mustIncludeValues: $mustIncludeValues
  ) {
    propertiesAggregations {
      integrationId
      property
      size
      hasMoreValues
      values {
        name
        amount
        globalAmount
      }
    }
  }
}
    `;

/**
 * __useGetActiveRecipientsAggregationsQuery__
 *
 * To run a query within a React component, call `useGetActiveRecipientsAggregationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveRecipientsAggregationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveRecipientsAggregationsQuery({
 *   variables: {
 *      rules: // value for 'rules'
 *      properties: // value for 'properties'
 *      systemId: // value for 'systemId'
 *      mustIncludeValues: // value for 'mustIncludeValues'
 *   },
 * });
 */
export function useGetActiveRecipientsAggregationsQuery(baseOptions: Apollo.QueryHookOptions<GetActiveRecipientsAggregationsQuery, GetActiveRecipientsAggregationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveRecipientsAggregationsQuery, GetActiveRecipientsAggregationsQueryVariables>(GetActiveRecipientsAggregationsDocument, options);
      }
export function useGetActiveRecipientsAggregationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveRecipientsAggregationsQuery, GetActiveRecipientsAggregationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveRecipientsAggregationsQuery, GetActiveRecipientsAggregationsQueryVariables>(GetActiveRecipientsAggregationsDocument, options);
        }
export type GetActiveRecipientsAggregationsQueryHookResult = ReturnType<typeof useGetActiveRecipientsAggregationsQuery>;
export type GetActiveRecipientsAggregationsLazyQueryHookResult = ReturnType<typeof useGetActiveRecipientsAggregationsLazyQuery>;
export type GetActiveRecipientsAggregationsQueryResult = Apollo.QueryResult<GetActiveRecipientsAggregationsQuery, GetActiveRecipientsAggregationsQueryVariables>;
export const GetCalculateRecipientsSizeDocument = gql`
    query getCalculateRecipientsSize($rules: [AudienceRuleInputType!]!, $systemId: String!) {
  getCalculateRecipientsSize(systemId: $systemId, rules: $rules) {
    all
    active
    inactive
    potential
  }
}
    `;

/**
 * __useGetCalculateRecipientsSizeQuery__
 *
 * To run a query within a React component, call `useGetCalculateRecipientsSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalculateRecipientsSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalculateRecipientsSizeQuery({
 *   variables: {
 *      rules: // value for 'rules'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetCalculateRecipientsSizeQuery(baseOptions: Apollo.QueryHookOptions<GetCalculateRecipientsSizeQuery, GetCalculateRecipientsSizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalculateRecipientsSizeQuery, GetCalculateRecipientsSizeQueryVariables>(GetCalculateRecipientsSizeDocument, options);
      }
export function useGetCalculateRecipientsSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalculateRecipientsSizeQuery, GetCalculateRecipientsSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalculateRecipientsSizeQuery, GetCalculateRecipientsSizeQueryVariables>(GetCalculateRecipientsSizeDocument, options);
        }
export type GetCalculateRecipientsSizeQueryHookResult = ReturnType<typeof useGetCalculateRecipientsSizeQuery>;
export type GetCalculateRecipientsSizeLazyQueryHookResult = ReturnType<typeof useGetCalculateRecipientsSizeLazyQuery>;
export type GetCalculateRecipientsSizeQueryResult = Apollo.QueryResult<GetCalculateRecipientsSizeQuery, GetCalculateRecipientsSizeQueryVariables>;
export const CalculateRecipientsSizeForFilterDocument = gql`
    query calculateRecipientsSizeForFilter($rules: [AudienceRuleInputType!]!, $systemId: String!, $recipientsFilter: CalculateRecipientsForFilterBodyRecipientsFilterEnum!) {
  calculateRecipientsSizeForFilter(
    systemId: $systemId
    rules: $rules
    recipientsFilter: $recipientsFilter
  )
}
    `;

/**
 * __useCalculateRecipientsSizeForFilterQuery__
 *
 * To run a query within a React component, call `useCalculateRecipientsSizeForFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateRecipientsSizeForFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateRecipientsSizeForFilterQuery({
 *   variables: {
 *      rules: // value for 'rules'
 *      systemId: // value for 'systemId'
 *      recipientsFilter: // value for 'recipientsFilter'
 *   },
 * });
 */
export function useCalculateRecipientsSizeForFilterQuery(baseOptions: Apollo.QueryHookOptions<CalculateRecipientsSizeForFilterQuery, CalculateRecipientsSizeForFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateRecipientsSizeForFilterQuery, CalculateRecipientsSizeForFilterQueryVariables>(CalculateRecipientsSizeForFilterDocument, options);
      }
export function useCalculateRecipientsSizeForFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateRecipientsSizeForFilterQuery, CalculateRecipientsSizeForFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateRecipientsSizeForFilterQuery, CalculateRecipientsSizeForFilterQueryVariables>(CalculateRecipientsSizeForFilterDocument, options);
        }
export type CalculateRecipientsSizeForFilterQueryHookResult = ReturnType<typeof useCalculateRecipientsSizeForFilterQuery>;
export type CalculateRecipientsSizeForFilterLazyQueryHookResult = ReturnType<typeof useCalculateRecipientsSizeForFilterLazyQuery>;
export type CalculateRecipientsSizeForFilterQueryResult = Apollo.QueryResult<CalculateRecipientsSizeForFilterQuery, CalculateRecipientsSizeForFilterQueryVariables>;
export const GetNotificationRecipientsCountDocument = gql`
    query getNotificationRecipientsCount($audienceIds: [String!]!, $endUsersIds: [String!], $systemId: String!, $recipientsFilter: RecipientsFilter!) {
  getNotificationRecipientsCount(
    systemId: $systemId
    audienceIds: $audienceIds
    endUsersIds: $endUsersIds
    recipientsFilter: $recipientsFilter
  )
}
    `;

/**
 * __useGetNotificationRecipientsCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationRecipientsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationRecipientsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationRecipientsCountQuery({
 *   variables: {
 *      audienceIds: // value for 'audienceIds'
 *      endUsersIds: // value for 'endUsersIds'
 *      systemId: // value for 'systemId'
 *      recipientsFilter: // value for 'recipientsFilter'
 *   },
 * });
 */
export function useGetNotificationRecipientsCountQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationRecipientsCountQuery, GetNotificationRecipientsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationRecipientsCountQuery, GetNotificationRecipientsCountQueryVariables>(GetNotificationRecipientsCountDocument, options);
      }
export function useGetNotificationRecipientsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationRecipientsCountQuery, GetNotificationRecipientsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationRecipientsCountQuery, GetNotificationRecipientsCountQueryVariables>(GetNotificationRecipientsCountDocument, options);
        }
export type GetNotificationRecipientsCountQueryHookResult = ReturnType<typeof useGetNotificationRecipientsCountQuery>;
export type GetNotificationRecipientsCountLazyQueryHookResult = ReturnType<typeof useGetNotificationRecipientsCountLazyQuery>;
export type GetNotificationRecipientsCountQueryResult = Apollo.QueryResult<GetNotificationRecipientsCountQuery, GetNotificationRecipientsCountQueryVariables>;
export const GetAudienceCombinationRecipientsCountDocument = gql`
    query getAudienceCombinationRecipientsCount($audienceIds: [String!]!, $endUsersIds: [String!], $systemId: String!) {
  getAudienceCombinationRecipientsCount(
    systemId: $systemId
    audienceIds: $audienceIds
    endUsersIds: $endUsersIds
  ) {
    all
    active
    inactive
    potential
  }
}
    `;

/**
 * __useGetAudienceCombinationRecipientsCountQuery__
 *
 * To run a query within a React component, call `useGetAudienceCombinationRecipientsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudienceCombinationRecipientsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudienceCombinationRecipientsCountQuery({
 *   variables: {
 *      audienceIds: // value for 'audienceIds'
 *      endUsersIds: // value for 'endUsersIds'
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetAudienceCombinationRecipientsCountQuery(baseOptions: Apollo.QueryHookOptions<GetAudienceCombinationRecipientsCountQuery, GetAudienceCombinationRecipientsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAudienceCombinationRecipientsCountQuery, GetAudienceCombinationRecipientsCountQueryVariables>(GetAudienceCombinationRecipientsCountDocument, options);
      }
export function useGetAudienceCombinationRecipientsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAudienceCombinationRecipientsCountQuery, GetAudienceCombinationRecipientsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAudienceCombinationRecipientsCountQuery, GetAudienceCombinationRecipientsCountQueryVariables>(GetAudienceCombinationRecipientsCountDocument, options);
        }
export type GetAudienceCombinationRecipientsCountQueryHookResult = ReturnType<typeof useGetAudienceCombinationRecipientsCountQuery>;
export type GetAudienceCombinationRecipientsCountLazyQueryHookResult = ReturnType<typeof useGetAudienceCombinationRecipientsCountLazyQuery>;
export type GetAudienceCombinationRecipientsCountQueryResult = Apollo.QueryResult<GetAudienceCombinationRecipientsCountQuery, GetAudienceCombinationRecipientsCountQueryVariables>;
export const CalculateRecipientsListDocument = gql`
    query calculateRecipientsList($systemId: String!, $query: RecipientsListQueryInput, $rules: [AudienceRuleInputType!]!) {
  calculateRecipientsList(systemId: $systemId, query: $query, rules: $rules) {
    ..._RecipientsResults
  }
}
    ${_RecipientsResultsFragmentDoc}`;

/**
 * __useCalculateRecipientsListQuery__
 *
 * To run a query within a React component, call `useCalculateRecipientsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateRecipientsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateRecipientsListQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      query: // value for 'query'
 *      rules: // value for 'rules'
 *   },
 * });
 */
export function useCalculateRecipientsListQuery(baseOptions: Apollo.QueryHookOptions<CalculateRecipientsListQuery, CalculateRecipientsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateRecipientsListQuery, CalculateRecipientsListQueryVariables>(CalculateRecipientsListDocument, options);
      }
export function useCalculateRecipientsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateRecipientsListQuery, CalculateRecipientsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateRecipientsListQuery, CalculateRecipientsListQueryVariables>(CalculateRecipientsListDocument, options);
        }
export type CalculateRecipientsListQueryHookResult = ReturnType<typeof useCalculateRecipientsListQuery>;
export type CalculateRecipientsListLazyQueryHookResult = ReturnType<typeof useCalculateRecipientsListLazyQuery>;
export type CalculateRecipientsListQueryResult = Apollo.QueryResult<CalculateRecipientsListQuery, CalculateRecipientsListQueryVariables>;
export const GetSelectedRecipientsAttributesDocument = gql`
    query getSelectedRecipientsAttributes($systemId: String!, $query: RecipientsListQueryInput, $selectedRecipiensRuleArray: [AudienceRuleInputType!]!) {
  calculateRecipientsList(
    systemId: $systemId
    query: $query
    rules: $selectedRecipiensRuleArray
  ) {
    recipients {
      id
      label
      ...UserRecipientAttributes
    }
  }
}
    ${UserRecipientAttributesFragmentDoc}`;

/**
 * __useGetSelectedRecipientsAttributesQuery__
 *
 * To run a query within a React component, call `useGetSelectedRecipientsAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedRecipientsAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedRecipientsAttributesQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      query: // value for 'query'
 *      selectedRecipiensRuleArray: // value for 'selectedRecipiensRuleArray'
 *   },
 * });
 */
export function useGetSelectedRecipientsAttributesQuery(baseOptions: Apollo.QueryHookOptions<GetSelectedRecipientsAttributesQuery, GetSelectedRecipientsAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectedRecipientsAttributesQuery, GetSelectedRecipientsAttributesQueryVariables>(GetSelectedRecipientsAttributesDocument, options);
      }
export function useGetSelectedRecipientsAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectedRecipientsAttributesQuery, GetSelectedRecipientsAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectedRecipientsAttributesQuery, GetSelectedRecipientsAttributesQueryVariables>(GetSelectedRecipientsAttributesDocument, options);
        }
export type GetSelectedRecipientsAttributesQueryHookResult = ReturnType<typeof useGetSelectedRecipientsAttributesQuery>;
export type GetSelectedRecipientsAttributesLazyQueryHookResult = ReturnType<typeof useGetSelectedRecipientsAttributesLazyQuery>;
export type GetSelectedRecipientsAttributesQueryResult = Apollo.QueryResult<GetSelectedRecipientsAttributesQuery, GetSelectedRecipientsAttributesQueryVariables>;
export const CreateReportDocument = gql`
    mutation createReport($note: String, $recipients: [String!]!, $dateRange: DateRange, $environmentId: String!, $timezoneOffset: Int!, $reportType: ReportTypes!, $reportParams: ReportParamsNew, $analyticsSource: AnalyticsSource, $language: Language!) {
  createReport(
    note: $note
    recipients: $recipients
    dateRange: $dateRange
    environmentId: $environmentId
    timezoneOffset: $timezoneOffset
    reportType: $reportType
    reportParams: $reportParams
    analyticsSource: $analyticsSource
    language: $language
  ) {
    recordsSent
  }
}
    `;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      note: // value for 'note'
 *      recipients: // value for 'recipients'
 *      dateRange: // value for 'dateRange'
 *      environmentId: // value for 'environmentId'
 *      timezoneOffset: // value for 'timezoneOffset'
 *      reportType: // value for 'reportType'
 *      reportParams: // value for 'reportParams'
 *      analyticsSource: // value for 'analyticsSource'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const CreateNotificationEngagementReportDocument = gql`
    mutation createNotificationEngagementReport($note: String, $recipients: [String!]!, $environmentId: String!, $notificationInfo: NotificationInfo!, $language: Language!) {
  createNotificationEngagementReport(
    note: $note
    recipients: $recipients
    environmentId: $environmentId
    notificationInfo: $notificationInfo
    language: $language
  )
}
    `;
export type CreateNotificationEngagementReportMutationFn = Apollo.MutationFunction<CreateNotificationEngagementReportMutation, CreateNotificationEngagementReportMutationVariables>;

/**
 * __useCreateNotificationEngagementReportMutation__
 *
 * To run a mutation, you first call `useCreateNotificationEngagementReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationEngagementReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationEngagementReportMutation, { data, loading, error }] = useCreateNotificationEngagementReportMutation({
 *   variables: {
 *      note: // value for 'note'
 *      recipients: // value for 'recipients'
 *      environmentId: // value for 'environmentId'
 *      notificationInfo: // value for 'notificationInfo'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCreateNotificationEngagementReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationEngagementReportMutation, CreateNotificationEngagementReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationEngagementReportMutation, CreateNotificationEngagementReportMutationVariables>(CreateNotificationEngagementReportDocument, options);
      }
export type CreateNotificationEngagementReportMutationHookResult = ReturnType<typeof useCreateNotificationEngagementReportMutation>;
export type CreateNotificationEngagementReportMutationResult = Apollo.MutationResult<CreateNotificationEngagementReportMutation>;
export type CreateNotificationEngagementReportMutationOptions = Apollo.BaseMutationOptions<CreateNotificationEngagementReportMutation, CreateNotificationEngagementReportMutationVariables>;
export const GetSystemVisualDesignsDocument = gql`
    query getSystemVisualDesigns($systemId: String!) {
  getSystemVisualDesigns(systemId: $systemId) {
    ...SystemVisualDesignFragment
  }
}
    ${SystemVisualDesignFragmentFragmentDoc}`;

/**
 * __useGetSystemVisualDesignsQuery__
 *
 * To run a query within a React component, call `useGetSystemVisualDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemVisualDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemVisualDesignsQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetSystemVisualDesignsQuery(baseOptions: Apollo.QueryHookOptions<GetSystemVisualDesignsQuery, GetSystemVisualDesignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemVisualDesignsQuery, GetSystemVisualDesignsQueryVariables>(GetSystemVisualDesignsDocument, options);
      }
export function useGetSystemVisualDesignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemVisualDesignsQuery, GetSystemVisualDesignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemVisualDesignsQuery, GetSystemVisualDesignsQueryVariables>(GetSystemVisualDesignsDocument, options);
        }
export type GetSystemVisualDesignsQueryHookResult = ReturnType<typeof useGetSystemVisualDesignsQuery>;
export type GetSystemVisualDesignsLazyQueryHookResult = ReturnType<typeof useGetSystemVisualDesignsLazyQuery>;
export type GetSystemVisualDesignsQueryResult = Apollo.QueryResult<GetSystemVisualDesignsQuery, GetSystemVisualDesignsQueryVariables>;
export const CreateSystemVisualDesignDocument = gql`
    mutation createSystemVisualDesign($systemId: String!, $systemVisualDesign: VisualDesignInputType!) {
  createSystemVisualDesign(
    systemId: $systemId
    systemVisualDesign: $systemVisualDesign
  ) {
    ...SystemVisualDesignFragment
  }
}
    ${SystemVisualDesignFragmentFragmentDoc}`;
export type CreateSystemVisualDesignMutationFn = Apollo.MutationFunction<CreateSystemVisualDesignMutation, CreateSystemVisualDesignMutationVariables>;

/**
 * __useCreateSystemVisualDesignMutation__
 *
 * To run a mutation, you first call `useCreateSystemVisualDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSystemVisualDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSystemVisualDesignMutation, { data, loading, error }] = useCreateSystemVisualDesignMutation({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      systemVisualDesign: // value for 'systemVisualDesign'
 *   },
 * });
 */
export function useCreateSystemVisualDesignMutation(baseOptions?: Apollo.MutationHookOptions<CreateSystemVisualDesignMutation, CreateSystemVisualDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSystemVisualDesignMutation, CreateSystemVisualDesignMutationVariables>(CreateSystemVisualDesignDocument, options);
      }
export type CreateSystemVisualDesignMutationHookResult = ReturnType<typeof useCreateSystemVisualDesignMutation>;
export type CreateSystemVisualDesignMutationResult = Apollo.MutationResult<CreateSystemVisualDesignMutation>;
export type CreateSystemVisualDesignMutationOptions = Apollo.BaseMutationOptions<CreateSystemVisualDesignMutation, CreateSystemVisualDesignMutationVariables>;
export const UpdateSystemVisualDesignDocument = gql`
    mutation updateSystemVisualDesign($id: String!, $systemId: String!, $systemVisualDesign: VisualDesignInputType!) {
  updateSystemVisualDesign(
    id: $id
    systemId: $systemId
    systemVisualDesign: $systemVisualDesign
  ) {
    ...SystemVisualDesignFragment
  }
}
    ${SystemVisualDesignFragmentFragmentDoc}`;
export type UpdateSystemVisualDesignMutationFn = Apollo.MutationFunction<UpdateSystemVisualDesignMutation, UpdateSystemVisualDesignMutationVariables>;

/**
 * __useUpdateSystemVisualDesignMutation__
 *
 * To run a mutation, you first call `useUpdateSystemVisualDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemVisualDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemVisualDesignMutation, { data, loading, error }] = useUpdateSystemVisualDesignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      systemId: // value for 'systemId'
 *      systemVisualDesign: // value for 'systemVisualDesign'
 *   },
 * });
 */
export function useUpdateSystemVisualDesignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSystemVisualDesignMutation, UpdateSystemVisualDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSystemVisualDesignMutation, UpdateSystemVisualDesignMutationVariables>(UpdateSystemVisualDesignDocument, options);
      }
export type UpdateSystemVisualDesignMutationHookResult = ReturnType<typeof useUpdateSystemVisualDesignMutation>;
export type UpdateSystemVisualDesignMutationResult = Apollo.MutationResult<UpdateSystemVisualDesignMutation>;
export type UpdateSystemVisualDesignMutationOptions = Apollo.BaseMutationOptions<UpdateSystemVisualDesignMutation, UpdateSystemVisualDesignMutationVariables>;
export const DeleteSystemVisualDesignDocument = gql`
    mutation deleteSystemVisualDesign($systemId: String!, $id: String!) {
  deleteSystemVisualDesign(systemId: $systemId, id: $id)
}
    `;
export type DeleteSystemVisualDesignMutationFn = Apollo.MutationFunction<DeleteSystemVisualDesignMutation, DeleteSystemVisualDesignMutationVariables>;

/**
 * __useDeleteSystemVisualDesignMutation__
 *
 * To run a mutation, you first call `useDeleteSystemVisualDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSystemVisualDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSystemVisualDesignMutation, { data, loading, error }] = useDeleteSystemVisualDesignMutation({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSystemVisualDesignMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSystemVisualDesignMutation, DeleteSystemVisualDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSystemVisualDesignMutation, DeleteSystemVisualDesignMutationVariables>(DeleteSystemVisualDesignDocument, options);
      }
export type DeleteSystemVisualDesignMutationHookResult = ReturnType<typeof useDeleteSystemVisualDesignMutation>;
export type DeleteSystemVisualDesignMutationResult = Apollo.MutationResult<DeleteSystemVisualDesignMutation>;
export type DeleteSystemVisualDesignMutationOptions = Apollo.BaseMutationOptions<DeleteSystemVisualDesignMutation, DeleteSystemVisualDesignMutationVariables>;
export const GetFeatureFlagsDocument = gql`
    query getFeatureFlags($systemId: String!) {
  getUserSettings(systemId: $systemId) {
    featureFlags
  }
}
    `;

/**
 * __useGetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetFeatureFlagsQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
      }
export function useGetFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
        }
export type GetFeatureFlagsQueryHookResult = ReturnType<typeof useGetFeatureFlagsQuery>;
export type GetFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagsLazyQuery>;
export type GetFeatureFlagsQueryResult = Apollo.QueryResult<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>;
export const GetHasRequiredWorkstationDocument = gql`
    query getHasRequiredWorkstation($systemId: String!, $environmentId: String!) {
  getUserSettings(systemId: $systemId) {
    hasRequiredWorkstation(environmentId: $environmentId)
  }
}
    `;

/**
 * __useGetHasRequiredWorkstationQuery__
 *
 * To run a query within a React component, call `useGetHasRequiredWorkstationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasRequiredWorkstationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasRequiredWorkstationQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useGetHasRequiredWorkstationQuery(baseOptions: Apollo.QueryHookOptions<GetHasRequiredWorkstationQuery, GetHasRequiredWorkstationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHasRequiredWorkstationQuery, GetHasRequiredWorkstationQueryVariables>(GetHasRequiredWorkstationDocument, options);
      }
export function useGetHasRequiredWorkstationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHasRequiredWorkstationQuery, GetHasRequiredWorkstationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHasRequiredWorkstationQuery, GetHasRequiredWorkstationQueryVariables>(GetHasRequiredWorkstationDocument, options);
        }
export type GetHasRequiredWorkstationQueryHookResult = ReturnType<typeof useGetHasRequiredWorkstationQuery>;
export type GetHasRequiredWorkstationLazyQueryHookResult = ReturnType<typeof useGetHasRequiredWorkstationLazyQuery>;
export type GetHasRequiredWorkstationQueryResult = Apollo.QueryResult<GetHasRequiredWorkstationQuery, GetHasRequiredWorkstationQueryVariables>;
export const GetSettingsDocument = gql`
    query getSettings($systemId: String!) {
  getUserSettings(systemId: $systemId) {
    settings
  }
}
    `;

/**
 * __useGetSettingsQuery__
 *
 * To run a query within a React component, call `useGetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
      }
export function useGetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
        }
export type GetSettingsQueryHookResult = ReturnType<typeof useGetSettingsQuery>;
export type GetSettingsLazyQueryHookResult = ReturnType<typeof useGetSettingsLazyQuery>;
export type GetSettingsQueryResult = Apollo.QueryResult<GetSettingsQuery, GetSettingsQueryVariables>;
export const GetUseElectronAnalyticsDocument = gql`
    query getUseElectronAnalytics($systemId: String!, $environmentId: String!) {
  getUserSettings(systemId: $systemId) {
    analyticsSources(environmentId: $environmentId) {
      useElectronAnalytics
    }
  }
}
    `;

/**
 * __useGetUseElectronAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetUseElectronAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUseElectronAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUseElectronAnalyticsQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useGetUseElectronAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetUseElectronAnalyticsQuery, GetUseElectronAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUseElectronAnalyticsQuery, GetUseElectronAnalyticsQueryVariables>(GetUseElectronAnalyticsDocument, options);
      }
export function useGetUseElectronAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUseElectronAnalyticsQuery, GetUseElectronAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUseElectronAnalyticsQuery, GetUseElectronAnalyticsQueryVariables>(GetUseElectronAnalyticsDocument, options);
        }
export type GetUseElectronAnalyticsQueryHookResult = ReturnType<typeof useGetUseElectronAnalyticsQuery>;
export type GetUseElectronAnalyticsLazyQueryHookResult = ReturnType<typeof useGetUseElectronAnalyticsLazyQuery>;
export type GetUseElectronAnalyticsQueryResult = Apollo.QueryResult<GetUseElectronAnalyticsQuery, GetUseElectronAnalyticsQueryVariables>;
export const GetAnalyticsSourcesDocument = gql`
    query getAnalyticsSources($systemId: String!, $environmentId: String!) {
  getUserSettings(systemId: $systemId) {
    analyticsSources(environmentId: $environmentId) {
      useElectronAnalytics
      hasLegacyAnalytics
      hasWorkstationAnalytics
    }
  }
}
    `;

/**
 * __useGetAnalyticsSourcesQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsSourcesQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useGetAnalyticsSourcesQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsSourcesQuery, GetAnalyticsSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsSourcesQuery, GetAnalyticsSourcesQueryVariables>(GetAnalyticsSourcesDocument, options);
      }
export function useGetAnalyticsSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsSourcesQuery, GetAnalyticsSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsSourcesQuery, GetAnalyticsSourcesQueryVariables>(GetAnalyticsSourcesDocument, options);
        }
export type GetAnalyticsSourcesQueryHookResult = ReturnType<typeof useGetAnalyticsSourcesQuery>;
export type GetAnalyticsSourcesLazyQueryHookResult = ReturnType<typeof useGetAnalyticsSourcesLazyQuery>;
export type GetAnalyticsSourcesQueryResult = Apollo.QueryResult<GetAnalyticsSourcesQuery, GetAnalyticsSourcesQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers {
  getUsers {
    id
    lastLoginDate
    role {
      displayName
      id
    }
    email
    firstName
    lastName
    status
    notificationsNumber
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetPlayableItemsDocument = gql`
    query getPlayableItems($systemId: String!, $environmentId: String!) {
  getPlayableItems(systemId: $systemId, environmentId: $environmentId) {
    Resource
    Shuttle
    SmartWalkThru
  }
}
    `;

/**
 * __useGetPlayableItemsQuery__
 *
 * To run a query within a React component, call `useGetPlayableItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayableItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayableItemsQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useGetPlayableItemsQuery(baseOptions: Apollo.QueryHookOptions<GetPlayableItemsQuery, GetPlayableItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayableItemsQuery, GetPlayableItemsQueryVariables>(GetPlayableItemsDocument, options);
      }
export function useGetPlayableItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayableItemsQuery, GetPlayableItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayableItemsQuery, GetPlayableItemsQueryVariables>(GetPlayableItemsDocument, options);
        }
export type GetPlayableItemsQueryHookResult = ReturnType<typeof useGetPlayableItemsQuery>;
export type GetPlayableItemsLazyQueryHookResult = ReturnType<typeof useGetPlayableItemsLazyQuery>;
export type GetPlayableItemsQueryResult = Apollo.QueryResult<GetPlayableItemsQuery, GetPlayableItemsQueryVariables>;
export const GetPlayableItemDocument = gql`
    query getPlayableItem($params: getPlayableItemParams!) {
  getPlayableItem(params: $params) {
    id
    name
    isModified
    resourceId
    publishStatus
    steps {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPlayableItemQuery__
 *
 * To run a query within a React component, call `useGetPlayableItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlayableItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlayableItemQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetPlayableItemQuery(baseOptions: Apollo.QueryHookOptions<GetPlayableItemQuery, GetPlayableItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlayableItemQuery, GetPlayableItemQueryVariables>(GetPlayableItemDocument, options);
      }
export function useGetPlayableItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlayableItemQuery, GetPlayableItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlayableItemQuery, GetPlayableItemQueryVariables>(GetPlayableItemDocument, options);
        }
export type GetPlayableItemQueryHookResult = ReturnType<typeof useGetPlayableItemQuery>;
export type GetPlayableItemLazyQueryHookResult = ReturnType<typeof useGetPlayableItemLazyQuery>;
export type GetPlayableItemQueryResult = Apollo.QueryResult<GetPlayableItemQuery, GetPlayableItemQueryVariables>;
export const GetImagesDocument = gql`
    query getImages($systemId: String!) {
  getImages(systemId: $systemId) {
    name
    extension
    lastModified
    size
    url
    isOriginalSrc
  }
}
    `;

/**
 * __useGetImagesQuery__
 *
 * To run a query within a React component, call `useGetImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImagesQuery({
 *   variables: {
 *      systemId: // value for 'systemId'
 *   },
 * });
 */
export function useGetImagesQuery(baseOptions: Apollo.QueryHookOptions<GetImagesQuery, GetImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImagesQuery, GetImagesQueryVariables>(GetImagesDocument, options);
      }
export function useGetImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImagesQuery, GetImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImagesQuery, GetImagesQueryVariables>(GetImagesDocument, options);
        }
export type GetImagesQueryHookResult = ReturnType<typeof useGetImagesQuery>;
export type GetImagesLazyQueryHookResult = ReturnType<typeof useGetImagesLazyQuery>;
export type GetImagesQueryResult = Apollo.QueryResult<GetImagesQuery, GetImagesQueryVariables>;
export const UploadImageDocument = gql`
    mutation uploadImage($fileData: UploadImageInput!) {
  uploadImage(fileData: $fileData)
}
    `;
export type UploadImageMutationFn = Apollo.MutationFunction<UploadImageMutation, UploadImageMutationVariables>;

/**
 * __useUploadImageMutation__
 *
 * To run a mutation, you first call `useUploadImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageMutation, { data, loading, error }] = useUploadImageMutation({
 *   variables: {
 *      fileData: // value for 'fileData'
 *   },
 * });
 */
export function useUploadImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageMutation, UploadImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImageMutation, UploadImageMutationVariables>(UploadImageDocument, options);
      }
export type UploadImageMutationHookResult = ReturnType<typeof useUploadImageMutation>;
export type UploadImageMutationResult = Apollo.MutationResult<UploadImageMutation>;
export type UploadImageMutationOptions = Apollo.BaseMutationOptions<UploadImageMutation, UploadImageMutationVariables>;
export const UploadImageFromUrlDocument = gql`
    mutation uploadImageFromUrl($fileData: UploadImageFromUrlInput!) {
  uploadImageFromUrl(fileData: $fileData)
}
    `;
export type UploadImageFromUrlMutationFn = Apollo.MutationFunction<UploadImageFromUrlMutation, UploadImageFromUrlMutationVariables>;

/**
 * __useUploadImageFromUrlMutation__
 *
 * To run a mutation, you first call `useUploadImageFromUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageFromUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageFromUrlMutation, { data, loading, error }] = useUploadImageFromUrlMutation({
 *   variables: {
 *      fileData: // value for 'fileData'
 *   },
 * });
 */
export function useUploadImageFromUrlMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageFromUrlMutation, UploadImageFromUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImageFromUrlMutation, UploadImageFromUrlMutationVariables>(UploadImageFromUrlDocument, options);
      }
export type UploadImageFromUrlMutationHookResult = ReturnType<typeof useUploadImageFromUrlMutation>;
export type UploadImageFromUrlMutationResult = Apollo.MutationResult<UploadImageFromUrlMutation>;
export type UploadImageFromUrlMutationOptions = Apollo.BaseMutationOptions<UploadImageFromUrlMutation, UploadImageFromUrlMutationVariables>;
export const DeleteImageDocument = gql`
    mutation deleteImage($fileData: DeleteImageInput!) {
  deleteImage(fileData: $fileData)
}
    `;
export type DeleteImageMutationFn = Apollo.MutationFunction<DeleteImageMutation, DeleteImageMutationVariables>;

/**
 * __useDeleteImageMutation__
 *
 * To run a mutation, you first call `useDeleteImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageMutation, { data, loading, error }] = useDeleteImageMutation({
 *   variables: {
 *      fileData: // value for 'fileData'
 *   },
 * });
 */
export function useDeleteImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImageMutation, DeleteImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImageMutation, DeleteImageMutationVariables>(DeleteImageDocument, options);
      }
export type DeleteImageMutationHookResult = ReturnType<typeof useDeleteImageMutation>;
export type DeleteImageMutationResult = Apollo.MutationResult<DeleteImageMutation>;
export type DeleteImageMutationOptions = Apollo.BaseMutationOptions<DeleteImageMutation, DeleteImageMutationVariables>;
export const GetUserAttributesDocument = gql`
    query getUserAttributes($numericSystemId: Float!) {
  getUserAttributes(numericSystemId: $numericSystemId) {
    name
    type
    value
    regex
  }
}
    `;

/**
 * __useGetUserAttributesQuery__
 *
 * To run a query within a React component, call `useGetUserAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAttributesQuery({
 *   variables: {
 *      numericSystemId: // value for 'numericSystemId'
 *   },
 * });
 */
export function useGetUserAttributesQuery(baseOptions: Apollo.QueryHookOptions<GetUserAttributesQuery, GetUserAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAttributesQuery, GetUserAttributesQueryVariables>(GetUserAttributesDocument, options);
      }
export function useGetUserAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAttributesQuery, GetUserAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAttributesQuery, GetUserAttributesQueryVariables>(GetUserAttributesDocument, options);
        }
export type GetUserAttributesQueryHookResult = ReturnType<typeof useGetUserAttributesQuery>;
export type GetUserAttributesLazyQueryHookResult = ReturnType<typeof useGetUserAttributesLazyQuery>;
export type GetUserAttributesQueryResult = Apollo.QueryResult<GetUserAttributesQuery, GetUserAttributesQueryVariables>;
export const AddUserAttributesDocument = gql`
    mutation addUserAttributes($userAttribute: UserAttributeInput!) {
  addUserAttributes(userAttribute: $userAttribute) {
    status
    details
  }
}
    `;
export type AddUserAttributesMutationFn = Apollo.MutationFunction<AddUserAttributesMutation, AddUserAttributesMutationVariables>;

/**
 * __useAddUserAttributesMutation__
 *
 * To run a mutation, you first call `useAddUserAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserAttributesMutation, { data, loading, error }] = useAddUserAttributesMutation({
 *   variables: {
 *      userAttribute: // value for 'userAttribute'
 *   },
 * });
 */
export function useAddUserAttributesMutation(baseOptions?: Apollo.MutationHookOptions<AddUserAttributesMutation, AddUserAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserAttributesMutation, AddUserAttributesMutationVariables>(AddUserAttributesDocument, options);
      }
export type AddUserAttributesMutationHookResult = ReturnType<typeof useAddUserAttributesMutation>;
export type AddUserAttributesMutationResult = Apollo.MutationResult<AddUserAttributesMutation>;
export type AddUserAttributesMutationOptions = Apollo.BaseMutationOptions<AddUserAttributesMutation, AddUserAttributesMutationVariables>;